<template>
  <div>
    <dx-popup
      :visible="popUpPrediksiKpVisible"
      :title="popUpPrediksiKpTitle"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :height="170"
      :width="550"
    >
      <div class="row">
        <div class="col">
          <div class="editors-container" v-if="naikPangkatPrediksiResponse">
            <DxDateBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :display-format="'dd/MM/yyyy'"
              :format="'dd/MM/yyyy'"
              width="100%"
              placeholder="Tgl Prediksi KP"
              label="Tgl Prediksi KP"
              v-model="naikPangkatPrediksiResponse.tgl"
            >
            </DxDateBox>

            <DxSelectBox
              :dataSource="golonganSource"
              value-expr="id"
              display-expr="nama"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              placeholder="Golongan"
              label="Golongan"
              v-model="naikPangkatPrediksiResponse.golongan_id"
            >
            </DxSelectBox>
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Tahun)"
              placeholder="Tahun"
              v-model="naikPangkatPrediksiResponse.masa_kerja"
            >
              <DxValidator>
                <DxNumericRule message="Tahun adalah angka" />
              </DxValidator>
            </DxTextBox>
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Bulan)"
              placeholder="Bulan"
              v-model="naikPangkatPrediksiResponse.masa_kerja_bulan"
            >
              <DxValidator>
                <DxNumericRule message="Tahun adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>

          <div class="editors-container" v-else>
            <DxDateBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :display-format="'dd/MM/yyyy'"
              :format="'dd/MM/yyyy'"
              width="100%"
              placeholder="Tgl Prediksi KP"
              label="Tgl Prediksi KP"
              v-model="naikPangkatPrediksiResponseAdd.tgl"
            >
            </DxDateBox>
            <DxSelectBox
              :dataSource="golonganSource"
              value-expr="id"
              display-expr="nama"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              placeholder="Golongan"
              label="Golongan"
              v-model="naikPangkatPrediksiResponseAdd.golongan_id"
            >
            </DxSelectBox>
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Tahun)"
              placeholder="Tahun"
              v-model="naikPangkatPrediksiResponseAdd.masa_kerja"
            >
              <DxValidator>
                <DxNumericRule message="Tahun adalah angka" />
              </DxValidator>
            </DxTextBox>
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Bulan)"
              placeholder="Bulan"
              v-model="naikPangkatPrediksiResponseAdd.masa_kerja_bulan"
            >
              <DxValidator>
                <DxNumericRule message="Bulan adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>
      </div>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsPrediksiKp"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsPrediksiKp"
      />
    </dx-popup>

    <dx-popup
      :visible="popUpPrediksiKgbVisible"
      :title="popUpPrediksiKgbTitle"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :height="200"
      :width="500"
    >
      <div class="row">
        <div class="col">
          <div class="editors-container" v-if="kgbPrediksiResponse">
            <DxDateBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :display-format="'dd/MM/yyyy'"
              :format="'dd/MM/yyyy'"
              width="100%"
              placeholder="Tgl Prediksi KGB"
              label="Tgl Prediksi KGB"
              v-model="kgbPrediksiResponse.tgl"
            >
            </DxDateBox>

            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Tahun)"
              placeholder="Tahun"
              v-model="kgbPrediksiResponse.masa_kerja"
            >
              <DxValidator>
                <DxNumericRule message="Tahun adalah angka" />
              </DxValidator>
            </DxTextBox>
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Bulan)"
              placeholder="Bulan"
              v-model="kgbPrediksiResponse.masa_kerja_bulan"
            >
              <!-- v-model="kgbPrediksiResponse.masa_kerja_bulan" -->
              <DxValidator>
                <DxNumericRule message="Bulan adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>

          <div class="editors-container" v-else>
            <DxDateBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :display-format="'dd/MM/yyyy'"
              :format="'dd/MM/yyyy'"
              width="100%"
              placeholder="Tgl Prediksi KGB"
              label="Tgl Prediksi KGB"
              v-model="kgbPrediksiResponseAdd.tgl"
            >
            </DxDateBox>

            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Tahun)"
              placeholder="Tahun"
              v-model="kgbPrediksiResponseAdd.masa_kerja"
            >
              <DxValidator>
                <DxNumericRule message="Tahun adalah angka" />
              </DxValidator>
            </DxTextBox>
            <DxTextBox
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Masa Kerja (Bulan)"
              placeholder="Bulan"
              v-model="kgbPrediksiResponseAdd.masa_kerja_bulan"
            >
              <!-- v-model="kgbPrediksiResponse.masa_kerja_bulan" -->
              <DxValidator>
                <DxNumericRule message="Bulan adalah angka" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>
      </div>

      <!-- <div class="editors-container"> -->
      <!-- <div class="left">
          <div class="button-container">
            <DxButton
              @click="validateClick('t1', $event)"
              text="save"
              type="default"
              class="validate"
              id="button-1"
            />
            <DxButton
              @click="startEditing"
              text="cancel"
              class="validate"
              id="button-2"
            />
          </div>
        </div> -->

      <!-- </div> -->
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsPrediksiKgb"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsPrediksiKgb"
      />
    </dx-popup>

    <dx-popup
      :visible="loadingVisible"
      :title="loadingTitle"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </dx-popup>

    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Detail Pegawai
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <div class="row">
        <!-- <div class="editors"> -->
        <div class="editors-container">
          <div class="col"><h5>Detail Pegawai</h5></div>

          <div class="col" style="padding-left: 10px" v-if="pegawaiSource">
            <DxSelectBox
              ref="selectPegawai"
              :dataSource="pegawaiSource"
              valueExpr="id"
              displayExpr="pilih"
              width="100%"
              label="Pilih Pegawai"
              placeholder="Pilih Pegawai"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="pegawaiId"
              @enter-key="lihatPegawai"
              @item-click="lihatPegawai"
              @selection-changed="lihatPegawai"
            >
            </DxSelectBox>
          </div>

          <div class="col" style="padding-left: 10px">
            <DxButton
              @click="lihatPegawai"
              text="lihat"
              styling-mode="outlined"
              type="default"
              class="validate"
              style="float: left"
            />
          </div>
        </div>
      </div>
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsPrediksiConfirm"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsPrediksiConfirm"
      />
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- :width="350"
          :height="240" -->
        <dx-popup
          :visible="popUpPrediksiConfirmVisible"
          :title="popUpPrediksiConfirmTitle"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="300"
          :height="150"
        >
          Tetapkan prediksi ini?

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="cancelButtonOptionsPrediksiConfirm"
          />

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="confirmButtonOptionsPrediksiConfirm"
          />
        </dx-popup>

        <DxPopup
          :width="350"
          :height="250"
          :show-title="true"
          title="Update Foto Pegawai"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          v-model:visible="popupVisible"
        >
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="updateButtonOptionsFoto"
          />

          <template #content>
            <label for="fileUploaderFoto">Foto profil pegawai:</label>
            <DxFileUploader
              ref="fileUploaderFoto"
              accept="image/*"
              upload-mode="useForm"
              name="files"
              multiple="false"
              @value-changed="handleFileUploader($event, 'pegawai_foto')"
            >
            </DxFileUploader>

            <br />
          </template>
        </DxPopup>

        <DxPopup
          v-model:visible="popupFileVisible"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-close-button="false"
          :show-title="true"
          :width="350"
          :height="370"
          container=".dx-viewport"
          title="Update File Arsip Pegawai"
        >
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="closeButtonOptions"
          />
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="deleteButtonOptions"
          />

          <div style="padding-bottom: 30px">
            <div class="uploader-label">Download file:</div>
            <div>
              <DxButton
                icon="download"
                text="Download"
                ref="fileDownloader"
                @click="downloadFile"
              />
            </div>
          </div>

          <div>
            <div class="uploader-label">Ganti dgn file baru:</div>
            <DxFileUploader
              ref="fileUploader"
              accept="*"
              upload-mode="useForm"
              name="files"
              multiple="false"
              @value-changed="handleFileUploader($event, 'file_path')"
            >
            </DxFileUploader>
          </div>
        </DxPopup>

        <DxPopup
          v-model:visible="popupPasanganVisible"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-close-button="false"
          :show-title="true"
          :height="inherit"
          container=".dx-viewport"
          title="Cari NIK Pegawai"
          :width="450"
        >
          <DxToolbarItem
            widget="dxButton"
            toolbar="top"
            locate-in-menu="always"
            :options="moreInfoButtonOptions"
          />

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="closeButtonOptionsPasangan"
          />

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="deleteButtonOptionsPasangan"
          />

          <!-- <div style="padding-bottom: 30px"> -->
          <div>
            <DxDataGrid
              class="dx-card"
              :data-source="pegawaiListDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
            >
              <dx-paging :page-size="numberingPageSize" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <dx-column data-field="nik" caption="NIK" :allow-sorting="true" />
              <dx-column
                data-field="nama"
                caption="Nama Pegawai"
                :allow-sorting="true"
              />
              <DxColumn
                data-field="id"
                caption="Pilih"
                cell-template="pilih-template"
              >
              </DxColumn>
              <!-- <DxColumn type="buttons">
                <DxButton hint="Pilih" icon="copy" @click="cloneIconClick" />
              </DxColumn> -->

              <template #pilih-template="{ data }">
                <div class="small-button-container">
                  <!-- {{ "rowIndex " + data.rowIndex }}
                    {{ showPopUpPasangan(data) }} -->

                  <DxButton
                    @click="handleClickPilihPasangan(data)"
                    icon="check"
                    hint="pilih"
                    type="default"
                  />
                </div>
              </template>
            </DxDataGrid>
          </div>
        </DxPopup>

        <div>
          <DxMenu
            :items="treeData"
            :show-first-submenu-mode="showFirstSubmenuModes"
            :orientation="orientation"
            :hide-submenu-on-mouse-leave="hideSubmenuOnMouseLeave"
            display-expr="text"
            @item-click="itemClick"
            selection-mode="single"
            :select-by-click="true"
          />

          <div class="title-container-pegawai">
            <div class="flag-pegawai" @click="popUpProfile($event)">
              <!-- <div class="flag-pegawai"> -->

              <img id="imageProfile" :src="imageUrl" v-if="pegawaiResponse" />

              <DxTooltip
                :hide-on-outside-click="false"
                target="#imageProfile"
                show-event="mouseenter"
                hide-event="mouseleave"
              >
                Klik utk ubah foto pegawai
              </DxTooltip>
            </div>
            <div>
              <div class="country-name" v-if="pegawaiResponse">
                {{ pegawaiResponse.nama }}
                <span style="padding-left: 20px">
                  <DxButton
                    v-if="can('pegawai-del')"
                    icon="remove"
                    text="Hapus"
                    @click="delPegawaiBtn"
                    styling-mode="outlined"
                    type="danger"
                  />
                  <DxButton
                    icon="download"
                    text="Download Data Keseluruhan"
                    @click="onExportingAll"
                    styling-mode="outlined"
                    type="default"
                  />
                </span>
              </div>
              <div v-if="pegawaiResponse">
                {{ statusAktifNama }} -
                {{ pegawaiResponse.nik }}
              </div>
            </div>
          </div>
          <br />
          <!-- <div class="title-pegawai"></div> -->
          <DxTabPanel
            id="tabpanel"
            v-model:selected-index="tabPanelIndex"
            :data-source="tabSource"
            :animation-enabled="true"
            item-title-template="title"
            item-template="currentTemplate"
            @titleClick="tabTitleClick"
          >
            <template #title="{ data: item }">
              <span class="tab-panel-title">{{ item.text }}</span>
            </template>

            <template #tBasic>
              <div v-if="!editing && pegawaiResponse">
                <div class="table-container">
                  <table class="table borderless" style="width: 100%">
                    <tbody>
                      <tr>
                        <td><strong>NIK</strong></td>
                        <td class="padded-column">
                          {{ pegawaiResponse.nik }}
                        </td>
                        <td></td>
                        <td><strong>Tempat lahir</strong></td>
                        <td class="padded-column">
                          {{ pegawaiResponse.tempat_lahir }}
                        </td>
                        <td></td>
                        <td><strong>Status aktif</strong></td>
                        <td class="padded-column">
                          {{ statusAktifNama }}
                        </td>
                      </tr>

                      <tr>
                        <td><strong>Nama</strong></td>
                        <td class="padded-column">
                          {{ pegawaiResponse.nama }}
                        </td>
                        <td></td>
                        <td><strong>Tgl lahir</strong></td>
                        <td class="padded-column">{{ formatTglLahir() }}</td>
                        <td></td>
                        <td><strong>Status pensiun jiwasraya</strong></td>
                        <td class="padded-column">
                          {{
                            displayBoolean(pegawaiResponse.pensiun_jiwasraya)
                          }}
                        </td>
                      </tr>

                      <tr>
                        <td><strong>Alamat</strong></td>
                        <td class="padded-column">
                          {{ pegawaiResponse.alamat }}
                        </td>
                        <td></td>
                        <td><strong>Jenis kelamin</strong></td>
                        <td class="padded-column">
                          {{ pegawaiResponse.jenis_kelamin }}
                        </td>
                        <td></td>
                        <td><strong>Status PPH</strong></td>
                        <td class="padded-column">
                          {{ displayBoolean(pegawaiResponse.pph) }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>No. telp</strong></td>
                        <td class="padded-column">
                          {{ pegawaiResponse.telp }}
                        </td>
                        <td></td>
                        <td><strong>Tgl mulai bekerja</strong></td>
                        <td class="padded-column">
                          {{ formatTglMulaiBekerja() }}
                        </td>
                        <td></td>
                        <td><strong>Status PTKP</strong></td>
                        <td class="padded-column">
                          {{ pegawaiResponse.status_ptkp }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Agama</strong></td>
                        <td class="padded-column">
                          {{ displayAgama(pegawaiResponse.agama) }}
                        </td>

                        <td></td>
                        <td><strong>Tgl pengangkatan</strong></td>
                        <td class="padded-column">
                          {{ formatTgl(pegawaiResponse.tgl_diangkat) }}
                        </td>
                        <td></td>
                        <td><strong>Tgl pensiun</strong></td>
                        <td class="padded-column">
                          {{ formatTgl(pegawaiResponse.pensiun_tgl) }}
                        </td>
                      </tr>

                      <tr>
                        <td colspan="8">
                          <dx-button
                            v-if="can('pegawai-update')"
                            text="Edit"
                            @click="startEditing"
                            style="float: right"
                            type="default"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="editing && pegawaiResponse" class="editors">
                <!-- <div v-if="editing && pegawaiResponse"> -->

                <div class="row row-cols-1 row-cols-md-3">
                  <div class="col">
                    <div class="editors-container">
                      <div class="left">
                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="NIK"
                          placeholder="NIK"
                          v-model="pegawaiResponse.nik"
                        >
                          <DxValidator>
                            <DxNumericRule message="NIK adalah angka" />
                          </DxValidator>
                        </DxTextBox>
                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Nama"
                          placeholder="Nama"
                          v-model="pegawaiResponse.nama"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxTextBox>
                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Alamat"
                          placeholder="Alamat"
                          v-model="pegawaiResponse.alamat"
                        >
                        </DxTextBox>

                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="No. telp"
                          placeholder="No. telp"
                          v-model="pegawaiResponse.telp"
                        >
                        </DxTextBox>

                        <DxSelectBox
                          :dataSource="agamaSource"
                          valueExpr="id"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Agama"
                          label="Agama"
                          v-model="pegawaiResponse.agama_id"
                        >
                        </DxSelectBox>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="editors-container">
                      <div class="left">
                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Tempat lahir"
                          placeholder="Tempat lahir"
                          v-model="pegawaiResponse.tempat_lahir"
                        >
                        </DxTextBox>
                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          :format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl lahir"
                          label="Tgl lahir"
                          v-model="pegawaiResponse.tgl_lahir"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxDateBox>

                        <DxSelectBox
                          :dataSource="jenisKelaminSource"
                          valueExpr="val"
                          displayExpr="nama"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Jenis kelamin"
                          label="Jenis kelamin"
                          v-model="pegawaiResponse.jenis_kelamin"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxSelectBox>

                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          :format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl mulai bekerja"
                          label="Tgl mulai bekerja"
                          v-model="pegawaiResponse.tgl_mulai_bekerja"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxDateBox>
                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          :format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl pengangkatan"
                          label="Tgl pengangkatan"
                          v-model="pegawaiResponse.tgl_diangkat"
                        >
                        </DxDateBox>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="editors-container">
                      <div class="left">
                        <DxSelectBox
                          :dataSource="statusAktifSource"
                          valueExpr="id"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Status aktif"
                          label="Status aktif"
                          v-model="pegawaiResponse.status_aktif_id"
                        >
                        </DxSelectBox>
                        <DxSelectBox
                          :dataSource="statusSource"
                          valueExpr="val"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Status pensiun jiwasraya"
                          label="Status pensiun jiwasraya"
                          v-model="pegawaiResponse.pensiun_jiwasraya"
                        >
                        </DxSelectBox>

                        <DxSelectBox
                          :dataSource="statusSource"
                          valueExpr="val"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Status PPH"
                          label="Status PPH"
                          v-model="pegawaiResponse.pph"
                        >
                        </DxSelectBox>
                        <!-- <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Status PTKP"
                          placeholder="Status PTKP"
                          v-model="pegawaiResponse.status_ptkp"
                        >
                        </DxTextBox> -->
                        <DxSelectBox
                          :dataSource="ptkpSource"
                          valueExpr="val"
                          displayExpr="val"
                          :searchEnabled="true"
                          searchExpr="val"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Status PTKP"
                          label="Status PTKP"
                          v-model="pegawaiResponse.status_ptkp"
                        >
                        </DxSelectBox>

                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          :format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl pensiun"
                          label="Tgl pensiun"
                          v-model="pegawaiResponse.pensiun_tgl"
                        >
                        </DxDateBox>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="editors-container">
                  <!-- <div class="left"></div> -->
                  <div class="left">
                    <div class="button-container">
                      <DxButton
                        v-if="can('pegawai-update')"
                        @click="validateClick('t1', $event)"
                        text="save"
                        type="default"
                        class="validate"
                        id="button-1"
                      />
                      <DxButton
                        @click="startEditing"
                        text="cancel"
                        class="validate"
                        id="button-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template #tKeluarga>
              <DxDataGrid
                id="dataGridKeluarga"
                ref="refDataGridKeluarga"
                :data-source="keluargaDataSource"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @option-changed="onOptionChangedKeluarga"
                @saving="onSavingKeluarga"
                @saved="onSavedKeluarga"
                @row-removed="onRemovedKeluarga"
                @init-new-row="initialPegawaiId($event, 'refDataGridKeluarga')"
                @exporting="onExporting($event, 'Data Keluarga Pegawai')"
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('keluarga')"
                />

                <DxSorting mode="multiple" />
                <dx-column
                  data-field="keluarga_hub_id"
                  caption="Hubungan Keluarga"
                  sort-order="asc"
                  data-type="number"
                >
                  <DxLookup
                    :data-source="keluargaHubSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="status_tertanggung"
                  caption="Status Tertanggung"
                  data-type="boolean"
                >
                  <DxLookup
                    :data-source="statusTertanggungSource"
                    value-expr="val"
                    display-expr="nama"
                  />
                </dx-column>

                <dx-column data-field="nama" caption="Nama" data-type="string">
                  <DxRequiredRuleDataGrid
                /></dx-column>

                <dx-column data-field="nik" caption="NIK" data-type="string">
                </dx-column>

                <dx-column
                  data-field="pasangan_id"
                  caption="NIK Pegawai PDAM"
                  data-type="number"
                >
                  <DxLookup
                    :data-source="pegawaiSource"
                    value-expr="id"
                    display-expr="pilih"
                  />
                </dx-column>

                <DxColumn
                  data-field="tempat_lahir"
                  caption="Tempat Lahir"
                  data-type="string"
                >
                </DxColumn>
                <dx-column
                  data-field="tgl_lahir"
                  caption="Tgl lahir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                </dx-column>

                <dx-column
                  data-field="perkawinan_status_id"
                  caption="Status Pernikahan"
                  data-type="number"
                >
                  <DxLookup
                    :data-source="perkawinanStatusSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </dx-column>

                <dx-column
                  data-field="jenis_kelamin"
                  caption="Jenis kelamin"
                  data-type="string"
                >
                  <DxLookup
                    :data-source="jenisKelaminSource"
                    valueExpr="val"
                    displayExpr="nama"
                  />
                </dx-column>
                <DxColumn
                  data-field="pekerjaan"
                  caption="Pekerjaan"
                  data-type="string"
                ></DxColumn>
                <dx-column
                  data-field="agama_id"
                  caption="Agama"
                  data-type="number"
                >
                  <DxLookup
                    :data-source="agamaSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </dx-column>
              </DxDataGrid>
            </template>
            <template #tPendidikan>
              <DxDataGrid
                ref="refDataGridPendidikan"
                id="dataGridPendidikan"
                :data-source="pendidikanDataSource"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @cell-click="cellClicked($event)"
                @init-new-row="
                  initialPegawaiId($event, 'refDataGridPendidikan')
                "
                @exporting="
                  onExporting($event, 'Data Riwayat Pendidikan Pegawai')
                "
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('pendidikan')"
                />
                <dx-column
                  data-field="status_penyesuaian"
                  caption="Penyesuaian"
                  data-type="boolean"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusPenyesuaianSource"
                  />
                  <!-- cell-template="penyesuaianTemplate" -->
                </dx-column>
                <!-- <template #penyesuaianTemplate="{ data }">
                  {{ formatPenyesuaian(data) }}
                </template> -->
                <dx-column
                  data-field="tgl_penyesuaian"
                  caption="Tgl Penyesuaian"
                  :dataType="'date'"
                  :display-format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                  :format="'dd/MM/yyyy'"
                >
                </dx-column>

                <dx-column
                  data-field="pendidikan_jenjang_id"
                  caption="Jenjang"
                  sort-order="asc"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="pendidikanJenjangSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="institusi"
                  caption="Nama institusi"
                  data-type="string"
                >
                  <DxRequiredRuleDataGrid
                /></dx-column>
                <dx-column
                  data-field="fakultas"
                  caption="Fakultas"
                  data-type="string"
                >
                </dx-column>
                <dx-column
                  data-field="jurusan"
                  caption="Jurusan"
                  data-type="string"
                >
                </dx-column>
                <dx-column data-field="ipk" caption="IPK" data-type="string">
                  <!-- <DxRequiredRuleDataGrid />
                  <DxPatternRule
                    :pattern="patternNumeric"
                    message="IPK adalah angka!"
                  /> -->
                </dx-column>
                <dx-column
                  data-field="tahun_mulai"
                  caption="Tahun Mulai"
                  data-type="number"
                >
                  <!-- <DxRequiredRuleDataGrid />
                  <DxPatternRule
                    :pattern="patternTahun"
                    message="Tahun salah"
                  /> -->
                </dx-column>
                <dx-column
                  data-field="tahun_lulus"
                  caption="Tahun Lulus"
                  data-type="number"
                >
                  <!-- <DxRequiredRuleDataGrid />
                  <DxRequiredRuleDataGrid />
                  <DxPatternRule
                    :pattern="patternTahun"
                    message="Tahun salah"
                  /> -->
                </dx-column>
                <dx-column
                  data-field="ijazah_no"
                  caption="Nomor Ijazah"
                  data-type="string"
                >
                </dx-column>
                <dx-column
                  data-field="ijazah_tgl"
                  caption="Tgl Ijazah"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                </dx-column>

                <DxColumn
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                />

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    <DxButton
                      :visible="setAdaFile(data.text)"
                      @click="handleClickDocument(data)"
                      icon="pdffile"
                    />
                  </div>
                </template>
              </DxDataGrid>
            </template>
            <template #tKgb>
              <p>Tgl Mulai Bekerja: {{ formatTglMulaiBekerja() }}</p>
              <p v-if="kgbPrediksiResponse">
                Prediksi KGB Selanjutnya:

                {{ printPrediksiKgb() }}
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiKgb()"
                  icon="edit"
                  text="Ubah"
                  styling-mode="outlined"
                  type="default"
                />

                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiKgbConfirm()"
                  icon="check"
                  text="Tetapkan prediksi ini"
                  styling-mode="outlined"
                  type="danger"
                />
              </p>
              <p v-else>
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiKgb()"
                  icon="add"
                  text="Buat Prediksi KGB"
                  styling-mode="outlined"
                  type="default"
                />
              </p>
              <DxDataGrid
                ref="refDataGridKgb"
                id="dataGridKgb"
                :data-source="kgbResponse"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="key"
                @init-new-row="initialPegawaiId($event, 'refDataGridKgb')"
                @saving="savingKgb"
                @saved="savedKgb"
                @exporting="onExporting($event, 'Data Riwayat KGB Pegawai ')"
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('kgb')"
                />
                <DxSorting mode="multiple" />
                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="status"
                  caption="Status"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>
                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>
                <dx-column
                  data-field="tgl"
                  caption="Tgl"
                  :dataType="'date'"
                  :display-format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                  :format="'dd/MM/yyyy'"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="masa_kerja"
                  caption="Masa Kerja (Tahun)"
                  cell-template="template-mk-tahun"
                  data-type="number"
                >
                </dx-column>
                <dx-column
                  data-field="masa_kerja_bulan"
                  caption="Masa Kerja (Bulan)"
                  cell-template="template-mk-bulan"
                  data-type="number"
                >
                </dx-column>
                <template #template-mk-bulan="{ data }">
                  {{ data.text }} Bulan
                </template>
                <template #template-mk-tahun="{ data }">
                  {{ data.text }} Tahun
                </template>
                <dx-column data-field="ket" caption="Ket"> </dx-column>
                <dx-column
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-editing="false"
                  :allow-adding="false"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                ></dx-column>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    {{ printAdaFile(data.text) }}
                    <DxButton
                      @click="
                        handleClickDocument(
                          data,
                          'simpeg_kgbs',
                          'refDataGridKgb'
                        )
                      "
                      icon="pdffile"
                    />
                  </div>
                </template>
              </DxDataGrid>
            </template>

            <template #tNaikPangkat>
              <p>Tgl Mulai Bekerja: {{ formatTglMulaiBekerja() }}</p>
              <p v-if="naikPangkatPrediksiResponse">
                Prediksi Kenaikan Pangkat Selanjutnya:

                {{ printPrediksiNaikPangkat() }}
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiKp()"
                  icon="edit"
                  text="Ubah"
                  styling-mode="outlined"
                  type="default"
                />

                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiKpConfirm()"
                  icon="check"
                  text="Tetapkan prediksi ini"
                  styling-mode="outlined"
                  type="danger"
                />
              </p>
              <p v-else>
                <DxButton
                  v-if="can('pegawai-update')"
                  @click="handleClickPrediksiKp()"
                  icon="add"
                  text="Buat Prediksi KP"
                  styling-mode="outlined"
                  type="default"
                />
              </p>
              <!-- key-expr="id" -->
              <DxDataGrid
                ref="refDataGridNaikPangkat"
                id="dataGridNaikPangkat"
                :data-source="naikPangkatResponse"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                @init-new-row="
                  initialPegawaiId($event, 'refDataGridNaikPangkat')
                "
                key-expr="key"
                @saving="savingNaikPangkat"
                @saved="savedNaikPangkat"
                @editing-start="onEditingStart"
                @exporting="
                  onExporting($event, 'Data Riwayat Kenaikan Pangkat Pegawai')
                "
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  v-bind="editingConfig('naikpangkat')"
                />
                <!-- :form="formConfig('naikpangkat')"  -->
                <DxSorting mode="multiple" />

                <dx-column
                  data-field="pegawai_id"
                  caption="Pegawai ID"
                  :visible="false"
                  data-type="number"
                >
                </dx-column>

                <!-- <dx-column
                  data-field="id"
                  caption="ID"
                  data-type="number"
                  :visible="false"
                >
                </dx-column> -->

                <dx-column
                  data-field="status"
                  caption="Status"
                  :dataType="'boolean'"
                  cell-template="templateStatus"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>

                <template #templateCapeg="{ data }">
                  {{ formatCheckbox(data, "80%") }}
                </template>

                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <!-- <template #templatePenyesuaian="{ data }">
                  {{ formatCheckbox(data, "Penyesuaian") }}
                </template> -->

                <dx-column
                  data-field="tgl"
                  caption="Tgl"
                  :dataType="'date'"
                  :display-format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                  :format="'dd/MM/yyyy'"
                  sort-order="asc"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="golongan_id"
                  caption="Golongan"
                  data-type="number"
                >
                  <DxLookup
                    :data-source="golonganSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="capeg"
                  caption="Capeg"
                  :dataType="'boolean'"
                  cell-template="templateCapeg"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>

                <template #capegTemplate="{ data }">
                  {{ formatCapeg(data) }}
                </template>
                <!-- <dx-column
                  data-field="status_penyesuaian"
                  caption="Status Penyesuaian"
                  :dataType="'boolean'"
                  cell-template="templatePenyesuaian"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column> -->

                <dx-column
                  data-field="tipe"
                  caption="Naik Pangkat"
                  :dataType="'string'"
                >
                  <DxLookup
                    display-expr="val"
                    value-expr="val"
                    :data-source="tipeKpSource"
                  />
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </dx-column>

                <DxColumn
                  data-field="masa_kerja"
                  caption="Masa Kerja (Tahun)"
                  cell-template="template-mk-tahun"
                  data-type="number"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>
                <DxColumn
                  data-field="masa_kerja_bulan"
                  caption="Masa Kerja (Bulan)"
                  cell-template="template-mk-bulan"
                  data-type="number"
                >
                  <DxRequiredRuleDataGrid />
                </DxColumn>

                <template #template-mk-bulan="{ data }">
                  {{ data.text }} Bulan
                </template>
                <template #template-mk-tahun="{ data }">
                  {{ data.text }} Tahun
                </template>
                <DxColumn data-field="ket" caption="Ket."> </DxColumn>
                <DxColumn
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-editing="false"
                  :allow-adding="false"
                  data-field="file_path"
                  caption="Dokumen"
                  cell-template="fileTemplate"
                  data-type="string"
                >
                </DxColumn>
                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    {{ printAdaFile(data.text) }}
                    <DxButton
                      @click="
                        handleClickDocument(
                          data,
                          'simpeg_naik_pangkats',
                          'refDataGridNaikPangkat'
                        )
                      "
                      icon="pdffile"
                    />
                  </div>
                </template>
              </DxDataGrid>
            </template>

            <template #tPekerjaan>
              <DxDataGrid
                ref="refDataGridPekerjaan"
                id="dataGridPekerjaan"
                :data-source="pekerjaanDataSource"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @init-new-row="initialPegawaiId($event, 'refDataGridPekerjaan')"
                @saving="savingPekerjaan"
                @exporting="
                  onExporting($event, 'Data Riwayat Pekerjaan Pegawai')
                "
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('pekerjaan')"
                />

                <dx-column
                  data-field="status"
                  caption="Status Pekerjaan"
                  cell-template="templateStatus"
                  data-type="boolean"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>
                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <dx-column
                  data-field="pegawai_status_id"
                  caption="Status Pegawai"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="pegawaiStatusSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="jabatan_id"
                  caption="Jabatan"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="jabatanSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="cabang_id"
                  caption="Cabang"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="cabangSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="unit_id"
                  caption="Unit"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="unitSource"
                  />
                </dx-column>
                <dx-column
                  data-field="bagian_id"
                  caption="Bagian"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="bagianSource"
                  />
                </dx-column>
                <dx-column
                  data-field="sub_bagian_id"
                  caption="Sub Bagian"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="subBagianSource"
                  />
                </dx-column>
                <dx-column
                  data-field="bidang_id"
                  caption="Bidang"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="bidangSource"
                  />
                </dx-column>

                <dx-column
                  data-field="sub_bidang_id"
                  caption="Sub Bidang"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="subBidangSource"
                  />
                </dx-column>
                <dx-column
                  data-field="seksi_id"
                  caption="Seksi"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="seksiSource"
                  />
                </dx-column>

                <dx-column
                  data-field="tgl_mulai_bekerja"
                  caption="Tgl Mulai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="tgl_akhir_bekerja"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                </dx-column>
                <dx-column
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-editing="false"
                  :allow-adding="false"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                ></dx-column>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    {{ printAdaFile(data.text) }}
                    <DxButton
                      @click="
                        handleClickDocument(
                          data,
                          'riwayat_pekerjaans',
                          'refDataGridPekerjaan'
                        )
                      "
                      icon="pdffile"
                    />
                  </div>
                </template>
              </DxDataGrid>
            </template>

            <template #tPlt>
              <DxDataGrid
                ref="refDataGridPlt"
                id="dataGridPlt"
                :data-source="pltDataSource"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @init-new-row="initialPegawaiId($event, 'refDataGridPlt')"
                @saving="savingPlt"
                @exporting="onExporting($event, 'Data Riwayat PLT Pegawai')"
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                />
                <dx-column
                  data-field="status"
                  caption="Status PLT"
                  cell-template="templateStatus"
                  data-type="boolean"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>
                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <dx-column
                  data-field="jabatan_id"
                  caption="Jabatan PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="jabatanSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="cabang_id"
                  caption="Cabang PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="cabangSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="unit_id"
                  caption="Unit PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="unitSource"
                  />
                </dx-column>

                <dx-column
                  data-field="bagian_id"
                  caption="Bagian PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="bagianSource"
                  />
                </dx-column>

                <dx-column
                  data-field="sub_bagian_id"
                  caption="Sub Bagian PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="subBagianSource"
                  />
                </dx-column>
                <dx-column
                  data-field="bidang_id"
                  caption="Bidang PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="bidangSource"
                  />
                </dx-column>
                <dx-column
                  data-field="sub_bidang_id"
                  caption="Sub Bidang PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="subBidangSource"
                  />
                </dx-column>
                <dx-column
                  data-field="seksi_id"
                  caption="Seksi PLT"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="seksiSource"
                  />
                </dx-column>

                <dx-column
                  data-field="tgl_mulai_bekerja"
                  caption="Tgl Mulai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="tgl_akhir_bekerja"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                </dx-column>
                <dx-column
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-editing="false"
                  :allow-adding="false"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                ></dx-column>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    {{ printAdaFile(data.text) }}
                    <DxButton
                      @click="
                        handleClickDocument(
                          data,
                          'riwayat_plts',
                          'refDataGridPlt'
                        )
                      "
                      icon="pdffile"
                    />
                  </div>
                </template>
              </DxDataGrid>
            </template>

            <template #tTransport>
              <DxDataGrid
                ref="refDataGridTransport"
                id="dataGridrTransport"
                :data-source="transportDataSource"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @init-new-row="initialPegawaiId($event, 'refDataGridTransport')"
                @exporting="
                  onExporting(
                    $event,
                    'Data Riwayat Pemegang Kendaraan Dinas Pegawai'
                  )
                "
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                  v-bind="editingConfig('transport')"
                />
                <dx-column
                  data-field="status"
                  caption="Status"
                  cell-template="templateStatus"
                  data-type="boolean"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>
                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <dx-column data-field="tipe" caption="Tipe" data-type="string">
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="plat_no"
                  caption="No. Plat"
                  data-type="string"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="tgl_awal"
                  caption="Tgl Awal"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="tgl_akhir"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                </dx-column>
                <dx-column
                  :allow-filtering="false"
                  :allow-sorting="false"
                  :allow-exporting="false"
                  :allow-editing="false"
                  :allow-adding="false"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                ></dx-column>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    {{ printAdaFile(data.text) }}
                    <DxButton
                      @click="
                        handleClickDocument(
                          data,
                          'riwayat_transports',
                          'refDataGridTransport'
                        )
                      "
                      icon="pdffile"
                    />
                  </div>
                </template>
              </DxDataGrid>
            </template>

            <template #tArsip>
              <DxDataGrid
                ref="refDataGridArsip"
                id="dataGridArsip"
                :data-source="pekerjaanDataSource"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @init-new-row="initialPegawaiId($event, 'refDataGridPekerjaan')"
                @saving="savingPekerjaan"
                @exporting="
                  onExporting($event, 'Data Riwayat Pekerjaan Pegawai')
                "
              >
                <dx-paging :page-size="numberingPageSize" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnFixing :enabled="true" />

                <DxEditing
                  :allow-updating="allow(can('pegawai-update'), allowUpdating)"
                  :allow-adding="allow(can('pegawai-create'), allowAdding)"
                  :allow-deleting="allow(can('pegawai-del'), allowDeleting)"
                  :mode="dxEditingMode"
                  :new-row-position="bottom"
                />

                <dx-column
                  data-field="status"
                  caption="Status Pekerjaan"
                  cell-template="templateStatus"
                  data-type="boolean"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>
                <template #templateStatus="{ data }">
                  <StatusTemplate :value="data.value" />
                </template>

                <dx-column
                  data-field="pegawai_status_id"
                  caption="Status Pegawai"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="pegawaiStatusSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="jabatan_id"
                  caption="Jabatan"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="jabatanSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="cabang_id"
                  caption="Cabang"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="cabangSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="unit_id"
                  caption="Unit"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="unitSource"
                  />
                </dx-column>
                <dx-column
                  data-field="bagian_id"
                  caption="Bagian"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="bagianSource"
                  />
                </dx-column>
                <dx-column
                  data-field="sub_bagian_id"
                  caption="Sub Bagian"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="subBagianSource"
                  />
                </dx-column>
                <dx-column
                  data-field="bidang_id"
                  caption="Bidang"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="bidangSource"
                  />
                </dx-column>

                <dx-column
                  data-field="sub_bidang_id"
                  caption="Sub Bidang"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="subBidangSource"
                  />
                </dx-column>
                <dx-column
                  data-field="seksi_id"
                  caption="Seksi"
                  data-type="number"
                >
                  <DxLookup
                    display-expr="nama"
                    value-expr="id"
                    :data-source="seksiSource"
                  />
                </dx-column>

                <dx-column
                  data-field="tgl_mulai_bekerja"
                  caption="Tgl Mulai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="tgl_akhir_bekerja"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  :format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                </dx-column>

                <DxColumn
                  :allowHeaderFiltering="false"
                  :allow-filtering="false"
                  :allow-sorting="true"
                  :allow-exporting="false"
                  :allow-editing="true"
                  :allow-adding="false"
                  cell-template="fileTemplate"
                  caption="Dokumen"
                  data-field="file_path"
                  data-type="string"
                  edit-cell-template="editFileTemplate"
                />

                <template #editFileTemplate="{ data }">
                  <div>
                    <DxFileUploader
                      accept="*"
                      upload-mode="useForm"
                      @value-changed="onFileValueChanged($event, { data })"
                    />
                  </div>
                </template>

                <template #fileTemplate="{ data }">
                  <div class="small-button-container">
                    {{ printAdaFile(data.text) }}
                    <DxButton
                      @click="
                        handleClickDocument(
                          data,
                          'riwayat_pekerjaans',
                          'refDataGridPekerjaan'
                        )
                      "
                      icon="pdffile"
                    />
                  </div>
                </template>
              </DxDataGrid>
            </template>
          </DxTabPanel>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="row">
        <!-- <div class="editors"> -->
        <div class="editors-container">
          <div class="col" style="padding-left: 10px">
            <DxSelectBox
              ref="selectDxediting"
              :dataSource="dxEditingSource"
              valueExpr="val"
              displayExpr="nama"
              width="10%"
              label="Editing Mode"
              placeholder="Editing Mode"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="dxEditingMode"
            >
            </DxSelectBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import api from "@/api";
import can from "@/haspermission";
import { BASE_URL } from "@/global-constants";
import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";
import DxMenu from "devextreme-vue/menu";
import DxTabPanel from "devextreme-vue/tab-panel";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import {
  DxValidator,
  DxRequiredRule,
  DxNumericRule,
} from "devextreme-vue/validator";
import notify from "devextreme/ui/notify";
import { DateTime } from "luxon";
import _ from "lodash";
import axios from "axios";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DxFileUploader } from "devextreme-vue/file-uploader";
// import DxPopover from "devextreme-vue/popover";
import { DxTooltip } from "devextreme-vue/tooltip";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxEditing,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  // DxButton,
  // DxToolbar,
  DxLookup,
  // DxItem,
  // DxPatternRule,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
} from "devextreme-vue/data-grid";
import { confirm } from "devextreme/ui/dialog";
import StatusTemplate from "./StatusTemplate.vue";

// import Cabangs from "./Cabangs.js";
// import PegawaiStatuses from "./PegawaiStatuses.js";
// import KeluargaHubs from "./KeluargaHubs.js";

// import StatusAktifs from "./StatusAktifs.js";

import { useGolonganStore } from "@/stores/GolonganStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";
import { useKeluargaHubStore } from "@/stores/KeluargaHubStore";
import { usePerkawinanStatusStore } from "@/stores/PerkawinanStatusStore";
import { usePendidikanJenjangStore } from "@/stores/PendidikanJenjangStore";
import { useAgamaStore } from "@/stores/AgamaStore";
import { useStatusAktifStore } from "@/stores/StatusAktifStore";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

function formatDateDisplay(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("dd/MM/yyyy");
}
function formatDateISO(dateOri) {
  if (!dateOri) return null;
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("yyyy-MM-dd");
}

// async function fetchDataPegawaiKeluarga() {
//   const odataStore = new ODataStore({
//     type: "odata",
//     url:
//       "http://127.0.0.1/odata/Keluargas?$orderby=keluarga_hub_id asc&$filter=pegawai_id eq " +
//       getPegawaiId(),
//     key: "id",
//     version: 4,
//     beforeSend: function (e) {
//       e.headers = {
//         "odata-version": "4.0",
//       };
//     },
//   });
//   const data = await odataStore.load({

//   });
//   return data;
// }

// async function fetchDatarTransport() {
//   const odataStore = new DataSource({
//     store: new ODataStore({
//       url: "http://127.0.0.1/odata/RiwayatTransports",
//       key: "id",
//       version: 4,
//       beforeSend: function (e) {
//         e.headers = {
//           "odata-version": "4.0",
//         };
//       },
//     }),
//     filter: ["pegawai_id", getPegawaiId()],
//   });
//   const data = await odataStore.load({});
//   return data;
// }

const tabMenus = [
  {
    items: [
      { text: "Data Pegawai", template: "tBasic", ref: "" },
      {
        text: "Data keluarga",
        template: "tKeluarga",
        ref: "refDataGridKeluarga",
      },

      {
        text: "riwayat pendidikan",
        template: "tPendidikan",
        ref: "refDataGridPendidikan",
      },
    ],
  },
  {
    items: [
      {
        text: "riwayat Pekerjaan",
        template: "tPekerjaan",
        ref: "refDataGridPekerjaan",
      },
      { text: "riwayat PLT", template: "tPlt", ref: "refDataGridPlt" },
      {
        text: "riwayat Pemegang Kendaraan Dinas",
        template: "tTransport",
        ref: "refDataGridTransport",
      },
      {
        text: "Kenaikan pangkat",
        template: "tNaikPangkat",
        ref: "refDataGridNaikPangkat",
      },
      { text: "kgb", template: "tKgb", ref: "refDataGridKgb" },
    ],
  },
  {
    items: [
      {
        text: "Data Arsip",
        template: "tArsip",
        ref: "refDataGridArsip",
      },
    ],
  },
];

export default {
  components: {
    DxMenu,
    DxTabPanel,
    DxSelectBox,
    DxTextBox,
    DxDateBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxNumericRule,
    DxDataGrid,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    // DxSelection,
    DxExport,
    // DxToolbar,
    // DxLookupDatagrid,
    DxLookup,
    // DxItem,
    DxEditing,
    DxRequiredRuleDataGrid,
    // DxPatternRule,
    DxSorting,
    DxTooltip,
    DxPopup,
    DxFileUploader,

    DxToolbarItem,
    // eslint-disable-next-line
    confirm,
    StatusTemplate,
    // DxPopover,
  },
  setup() {
    const golonganStore = useGolonganStore();
    const jabatanStore = useJabatanStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const pegawaiStatusStore = usePegawaiStatusStore();
    const keluargaHubStore = useKeluargaHubStore();
    const perkawinanStatusStore = usePerkawinanStatusStore();
    const pendidikanJenjangStore = usePendidikanJenjangStore();
    const agamaStore = useAgamaStore();
    const statusAktifStore = useStatusAktifStore();
    return {
      golonganStore,
      jabatanStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      cabangStore,
      unitStore,
      pegawaiStatusStore,
      keluargaHubStore,
      perkawinanStatusStore,
      pendidikanJenjangStore,
      agamaStore,
      statusAktifStore,
    };
    // const picture = "images/employees/06.png";
    // const imageUrl = `https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/${picture}`;
  },
  data() {
    const showSubmenuModes = [
      {
        name: "onHover",
        delay: { show: 0, hide: 500 },
      },
      {
        name: "onClick",
        delay: { show: 0, hide: 300 },
      },
    ];

    return {
      dxEditingMode: "popup",
      loadingVisible: false,
      loadingTitle: "Loading data pegawai...",
      pegawaiId: this.$route.query.id,
      selectedValue: null,
      searchQuery: "",

      transportDataSource: null,
      pekerjaanDataSource: null,
      pltDataSource: null,
      dataGridPopupCurrDataIdPendidikan: null,
      moreInfoButtonOptions: {
        text: "More info",
        onClick: () => {
          const message = "test";
          // const message = `More info about ${this.currentEmployee.FirstName} ${this.currentEmployee.LastName}`;
          notify(
            {
              message,
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "success",
            3000
          );
        },
      },
      emailButtonOptions: {
        icon: "email",
        text: "Send",
        onClick: () => {
          const message = "test email";
          // const message = `Email is sent to ${this.currentEmployee.FirstName} ${this.currentEmployee.LastName}`;
          notify(
            {
              message,
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "success",
            3000
          );
        },
      },
      closeButtonOptions: {
        text: "Upload",
        onClick: () => {
          //tambahkan ijazahfile ke array
          this.uploadFile();
          this.popupFileVisible = false;
        },
      },
      deleteButtonOptions: {
        text: "Hapus File",
        type: "danger",
        onClick: () => {
          let result = confirm(
            "<strong>Yakin menghapus File?</strong>",
            "Konfirmasi Hapus File"
          );
          result.then((dialogResult) => {
            if (dialogResult) {
              this.uploadFile("delete");
              this.popupFileVisible = false;
            }
          });
        },
      },

      confirmButtonOptionsPrediksiConfirm: {
        text: "Tetapkan Prediksi",
        onClick: (e) => {
          //tambahkan ijazahfile ke array
          console.log("tetapkan prediksi", e);

          if (this.prediksiConfirmKlik === "kgb") this.tetapkanPrediksiKgb();
          else this.tetapkanPrediksiKp();
          this.popUpPrediksiConfirmVisible = false;
        },
      },

      cancelButtonOptionsPrediksiKgb: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popUpPrediksiKgbVisible = false;
        },
      },
      cancelButtonOptionsPrediksiKp: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popUpPrediksiKpVisible = false;
        },
      },

      cancelButtonOptionsPrediksiConfirm: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popUpPrediksiConfirmVisible = false;
        },
      },

      confirmButtonOptionsPrediksiKgb: {
        text: "Simpan",
        onClick: (e) => {
          this.simpanPrediksiKgb(e);
        },
      },

      confirmButtonOptionsPrediksiKp: {
        text: "Simpan",
        onClick: (e) => {
          this.simpanPrediksiKp(e);
        },
      },

      closeButtonOptionsPasangan: {
        text: "Close",
        onClick: () => {
          //tambahkan ijazahfile ke array
          // this.ijazahFilePrep();
          this.popupPasanganVisible = false;
        },
      },
      deleteButtonOptionsPasangan: {
        text: "Hapus Pasangan",
        type: "danger",
        onClick: () => {
          //tambahkan ijazahfile ke array
          // this.ijazahFilePrep();
          this.popupPasanganVisible = false;
          this.handleClickDeletePasangan();
        },
      },
      updateButtonOptionsFoto: {
        text: "Update",
        onClick: () => {
          this.updateFotoPegawai();
        },
      },

      popupVisible: false,
      popupFileVisible: false,
      popupPasanganVisible: false,
      // serverUrl: "http://127.0.0.1/",
      serverUrl: `${BASE_URL}/`,
      imageUrl: null,
      numberingPageSize: 20,
      // "http://127.0.0.1/profiles/GBNDPZZIyfQNIbnM0UKInlyaTH527AYmANZKsabf.png",

      dataGridValid: true,
      patternTahun: /^\d{4}$/i,
      patternNumeric: /^\d+(?:[.,]\d+)?$/,

      pegawaiSource: null,

      pegawaiResponse: null,
      statusAktifNama: null,

      keluargaDataSource: null,
      naikPangkatResponse: null,
      naikPangkatPrediksiResponse: null,
      naikPangkatPrediksiResponseAdd: {
        tgl: null,
        golongan_id: null,
        masa_kerja: null,
        masa_kerja_bulan: null,
      },

      kgbResponse: null,
      pendidikanDataSource: null,

      keluargaHubSource: null,
      perkawinanStatusSource: null,
      agamaSource: null,
      pendidikanJenjangSource: null,

      statusAktifSource: null,

      bagianSource: null,

      bidangSource: null,

      subBagianSource: null,

      seksiSource: null,

      subBidangSource: null,

      cabangSource: null,

      unitSource: null,

      pegawaiStatusSource: null,

      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      dxEditingSource: [
        { val: "row", nama: "Baris" },
        { val: "popup", nama: "Form popup" },
      ],
      ptkpSource: [
        { val: null },
        { val: "TK" },
        { val: "K0" },
        { val: "K1" },
        { val: "K2" },
        { val: "K3" },
      ],
      tipeKpSource: [
        { val: "Reguler" },
        { val: "Penyesuaian" },
        { val: "Pilihan" },
      ],
      statusTertanggungSource: [
        { val: true, nama: "Tertanggung" },
        { val: false, nama: "" },
      ],

      statusPenyesuaianSource: [
        { val: true, nama: "Penyesuaian" },
        { val: false, nama: "" },
      ],

      tabPanelIndex: 0,
      tabMenus: tabMenus,
      tabSource: tabMenus[0].items,

      currentTemplate: "tBasic",
      treeData: [
        {
          id: 1,
          text: "Data Personal",
          templateIndex: 0,
          selected: true,
        },
        {
          id: 2,
          text: "Data Pekerjaan",
          templateIndex: 1,
          selected: false,
        },
        {
          id: 2,
          text: "Data Arsip",
          templateIndex: 2,
          selected: false,
        },
      ],

      showSubmenuModes,
      showFirstSubmenuModes: showSubmenuModes[1],
      orientation: "horizontal",
      hideSubmenuOnMouseLeave: false,
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",
      editing: false,
      keluargaAxios: {
        insert: [],
        update: [],
        remove: [],
      },
      pendidikanAxios: {
        insert: [],
        update: [],
        remove: [],
      },

      rPekerjaanAxios: {
        insert: [],
        update: [],
        remove: [],
      },

      rTransportAxios: {
        insert: [],
        update: [],
        remove: [],
      },

      animationConfig: {
        show: {
          type: "pop",
          from: {
            scale: 0,
          },
          to: {
            scale: 1,
          },
        },
        hide: {
          type: "fade",
          from: 1,
          to: 0,
        },
      },
      fotoPegawai: null,
      fileIjazahTemp: null,
      fileIjazahTempRowId: null,
      ijazahFileAxios: [],
      rKeluargaRowIndex: null,
      file: null,
      fileUrl: null,
      fileName: null,
      filePath: null,
      fileTableId: null,
      fileTable: null,
      fileTableRef: null,
      focusedRowKeyKeluarga: 0,
      jenisKelaminSource: [
        { val: "L", nama: "Laki-Laki" },
        { val: "P", nama: "Perempuan" },
      ],
      kgbPrediksiResponse: null,
      kgbPrediksiResponseAdd: {
        tgl: null,
        masa_kerja: null,
        masa_kerja_bulan: null,
      },

      allowEditing: true,
      allowAdding: true,
      allowDeleting: true,
      golonganSource: null,
      jabatanSource: null,
      popUpPrediksiConfirmVisible: false,
      popUpPrediksiConfirmTitle: "",
      popUpPrediksiKgbVisible: false,
      popUpPrediksiKgbTitle: "Edit Prediksi KGB",
      popUpPrediksiKpVisible: false,
      popUpPrediksiKpTitle: "Edit Prediksi Kenaikan Pangkat",
      prediksiConfirmKlik: null,
    };
  },
  computed: {},

  async mounted() {
    // this.golonganStore.reset(),
    //   this.jabatanStore.reset(),
    //   this.bagianStore.reset(),
    //   this.bidangStore.reset(),
    //   this.subBagianStore.reset(),
    //   this.subBidangStore.reset(),
    //   this.seksiStore.reset(),
    //   this.cabangStore.reset(),
    //   this.unitStore.reset(),
    //   this.pegawaiStatusStore.reset(),
    //   this.keluargaHubStore.reset(),
    //   this.perkawinanStatusStore.reset(),
    //   this.pendidikanJenjangStore.reset(),
    //   this.agamaStore.reset(),
    //   this.statusAktifStore.reset(),
    await this.fetchPegawaiSource();

    this.golonganSource = await this.golonganStore.get();
    // this.jabatanStore.reset();
    this.jabatanSource = await this.jabatanStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
    this.pegawaiStatusSource = await this.pegawaiStatusStore.get();
    this.keluargaHubSource = await this.keluargaHubStore.get();
    this.perkawinanStatusSource = await this.perkawinanStatusStore.get();
    this.pendidikanJenjangSource = await this.pendidikanJenjangStore.get();
    this.agamaSource = await this.agamaStore.get();
    this.statusAktifSource = await this.statusAktifStore.get();
    console.log(this.agamaStore.filter(2)[0]);

    console.log("mounted golonganSource", this.golonganSource);

    console.log("CURRENTROUTEMOUNTED", this.pegawaiId);
    this.kgbPrediksiResponse = await this.fetchDataKgbPrediksi();
    this.pegawaiResponse = await this.fetchDataPegawai();
    document.title = this.pegawaiResponse.nama + " - Detail Pegawai";
    this.keluargaDataSource = this.fetchDataKeluarga();
    this.pendidikanDataSource = this.fetchDataPendidikan();
    this.naikPangkatResponse = this.fetchDataNaikPangkat();
    this.naikPangkatPrediksiResponse =
      await this.fetchDataNaikPangkatPrediksi();

    this.kgbResponse = this.fetchDataKgb();
    this.pekerjaanDataSource = this.fetchDataPekerjaan();
    this.pltDataSource = this.fetchDataPlt();

    this.transportDataSource = this.fetchDataTransport();
    this.imageUrl = this.serverUrl + this.pegawaiResponse.pegawai_foto_path;

    // this.statusAktifSource = await StatusAktifs.get();

    this.displayStatusAktif(this.pegawaiResponse.status_aktif_id);
    this.disableDatagridBasedOnStatusAktifPegawai();
  },
  watch: {
    searchQuery: {
      handler(newValue) {
        this.applySearch(newValue);
      },
    },
  },
  methods: {
    onEditingStart() {
      this.file = null;
      this.fileName = null;
      this.filePath = null;
    },
    updateQueryStringParameter(uri, key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf("?") !== -1 ? "&" : "?";
      if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
      } else {
        return uri + separator + key + "=" + value;
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    onFileValueChanged(e, cellInfo) {
      const uploadButton = e.element.querySelector(
        ".dx-fileuploader-upload-button"
      );
      if (uploadButton) {
        uploadButton.style.display = "none"; // Hide the upload button
      }

      if (e.value && e.value[0]) {
        const fileNameTemp = e.value[0].name;
        const fileExtension = fileNameTemp.substring(
          fileNameTemp.lastIndexOf(".") + 1
        );
        this.file = e.value[0];
        var guid = this.uuidv4();
        this.fileName = guid + "." + fileExtension;
        this.filePath = "files/" + this.fileName;
        cellInfo.data.setValue(this.filePath);
      }
    },

    setAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },
    editingConfig(table) {
      if (this.dxEditingMode === "popup") {
        return {
          form: this.formConfig(table),
        };
      }
      return {};
    },
    formConfig(table) {
      const tables = {
        naikpangkat: [
          "status",
          "tgl",
          "golongan_id",
          "capeg",
          "tipe",
          "masa_kerja",
          "masa_kerja_bulan",
          "ket",
        ],
        kgb: ["status", "tgl", "masa_kerja", "masa_kerja_bulan", "ket"],
        transport: ["status", "tipe", "plat_no", "tgl_awal", "tgl_akhir"],
        pekerjaan: [
          "status",
          "pegawai_status_id",
          "jabatan_id",
          "cabang_id",
          "unit_id",
          "bagian_id",
          "sub_bagian_id",
          "bidang_id",
          "sub_bidang_id",
          "seksi_id",
          "tgl_mulai_bekerja",
          "tgl_akhir_bekerja",
        ],
        pendidikan: [
          "status_penyesuaian",
          "tgl_penyesuaian",
          "pendidikan_jenjang_id",
          "institusi",
          "fakultas",
          "jurusan",
          "ipk",
          "tahun_mulai",
          "tahun_lulus",
          "ijazah_no",
          "ijazah_tgl",
        ],
        keluarga: [
          "keluarga_hub_id",
          "status_tertanggung",
          "nama",
          "nik",
          "pasangan_id",
          "tempat_lahir",
          "tgl_lahir",
          "perkawinan_status_id",
          "jenis_kelamin",
          "pekerjaan",
          "agama_id",
        ],
      };
      return {
        items: [
          {
            itemType: "group",
            colCount: 2,
            colSpan: 2,
            items: tables[table] || [],
          },
        ],
      };
    },
    allowFileUpload() {
      var hasil = this.allow(this.can("pegawai-update"), this.allowUpdating);
      console.log("debug allowfileupload ", hasil);

      return hasil;
    },
    printAdaFile(e) {
      if (_.isEmpty(e)) return;
      else return "Ada ";
    },

    async fetchPegawaiSource() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      const response = await axios.get(
        `${API_BASE_URL}/simpeg_pegawai`,
        config
      );
      const modifiedData = response.data.data.map((item) => {
        return {
          ...item,
          pilih: item.nik + " - " + item.nama,
        };
      });

      this.pegawaiSource = modifiedData;
    },
    can,

    prepExcelTgl(tgl) {
      if (tgl === null) return null;

      const dateObj = DateTime.fromISO(tgl);
      return dateObj.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    prepExcelCapeg(capeg) {
      if (capeg) return "80%";
      return "";
    },
    prepExcelExpand(tableName, colName) {
      //misal agama.nama, ketika agama = null, maka nama akan error
      if (tableName === null) return null;
      return tableName[colName];
    },
    prepExcelBool(val) {
      if (val) return "Aktif";
      return "Tidak Aktif";
    },
    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },
    wbContentPegawai(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];
      this.wbAoa(ws, "Data Pegawai", "A" + row);
      row += 2;
      this.wbAoa(ws, "NIK:", "A" + row);
      this.wbAoa(ws, data.nik, "B" + row);
      this.wbAoa(ws, "Tempat Lahir:", "D" + row);
      this.wbAoa(ws, data.tempat_lahir, "E" + row);
      this.wbAoa(ws, "Status Aktif:", "G" + row);
      this.wbAoa(ws, data.status_aktif.nama, "H" + row);
      row += 1;
      this.wbAoa(ws, "Nama:", "A" + row);
      this.wbAoa(ws, data.nama, "B" + row);
      this.wbAoa(ws, "Tgl Lahir:", "D" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.tgl_lahir), "E" + row);
      this.wbAoa(ws, "Status Pensiun Jiwasraya:", "G" + row);
      this.wbAoa(ws, this.prepExcelBool(data.pensiun_jiwasraya), "H" + row);
      row += 1;
      this.wbAoa(ws, "Alamat:", "A" + row);
      this.wbAoa(ws, data.alamat, "B" + row);
      this.wbAoa(ws, "Jenis Kelamin:", "D" + row);
      this.wbAoa(ws, data.jenis_kelamin, "E" + row);
      this.wbAoa(ws, "Status PPH:", "G" + row);
      this.wbAoa(ws, this.prepExcelBool(data.pph), "H" + row);
      row += 1;
      this.wbAoa(ws, "No. Telp:", "A" + row);
      this.wbAoa(ws, data.telp, "B" + row);
      this.wbAoa(ws, "Tgl Mulai Bekerja:", "D" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.tgl_mulai_bekerja), "E" + row);
      this.wbAoa(ws, "Status PTKP:", "G" + row);
      this.wbAoa(ws, data.status_ptkp, "H" + row);
      row += 1;
      this.wbAoa(ws, "Agama:", "A" + row);
      this.wbAoa(ws, this.prepExcelExpand(data.agama, "nama"), "B" + row);
      this.wbAoa(ws, "Tgl Pengangkatan:", "D" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.tgl_diangkat), "E" + row);
      this.wbAoa(ws, "Tgl Pensiun:", "G" + row);
      this.wbAoa(ws, this.prepExcelTgl(data.pensiun_tgl), "H" + row);
    },

    wbContentKeluarga(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];
      var numbering = 1;
      this.wbAoa(ws, "Data Keluarga", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Hubungan Keluarga", "B" + row);
      this.wbAoa(ws, "Status Tertanggung", "C" + row);
      this.wbAoa(ws, "Nama", "D" + row);
      this.wbAoa(ws, "NIK", "E" + row);
      this.wbAoa(ws, "NIK Pegawai PDAM", "F" + row);
      this.wbAoa(ws, "Tempat Lahir", "G" + row);
      this.wbAoa(ws, "Tgl Lahir", "H" + row);
      this.wbAoa(ws, "Status Pernikahan", "I" + row);
      this.wbAoa(ws, "Jenis Kelamin", "J" + row);
      this.wbAoa(ws, "Pekerjaan", "K" + row);
      this.wbAoa(ws, "Agama", "L" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.keluarga_hub, "nama"), "B" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status_tertanggung), "C" + row);
        this.wbAoa(ws, e.nama, "D" + row);
        this.wbAoa(ws, e.nik, "E" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.pasangan, "nik"), "F" + row);
        this.wbAoa(ws, e.tempat_lahir, "G" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_lahir), "H" + row);
        this.wbAoa(
          ws,
          this.prepExcelExpand(e.perkawinan_status, "nama"),
          "I" + row
        );
        this.wbAoa(ws, e.jenis_kelamin, "J" + row);
        this.wbAoa(ws, e.pekerjaan, "K" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.agama, "nama"), "L" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },
    wbContentPendidikan(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Pendidikan", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Penyesuaian", "B" + row);
      this.wbAoa(ws, "Tgl Penyesuaian", "C" + row);
      this.wbAoa(ws, "Jenjang", "D" + row);
      this.wbAoa(ws, "Nama Institusi", "E" + row);
      this.wbAoa(ws, "Fakultas", "F" + row);
      this.wbAoa(ws, "Jurusan", "G" + row);
      this.wbAoa(ws, "IPK", "H" + row);
      this.wbAoa(ws, "Tahun Mulai", "I" + row);
      this.wbAoa(ws, "Tahun Lulus", "J" + row);
      this.wbAoa(ws, "Nomor Ijazah", "K" + row);
      this.wbAoa(ws, "Tgl Ijazah", "L" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status_penyesuaian), "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_penyesuaian), "C" + row);
        this.wbAoa(
          ws,
          this.prepExcelExpand(e.pendidikan_jenjang, "nama"),
          "D" + row
        );
        this.wbAoa(ws, e.institusi, "E" + row);
        this.wbAoa(ws, e.fakultas, "F" + row);
        this.wbAoa(ws, e.jurusan, "G" + row);
        this.wbAoa(ws, e.ipk, "H" + row);
        this.wbAoa(ws, e.tahun_mulai, "I" + row);
        this.wbAoa(ws, e.tahun_lulus, "J" + row);
        this.wbAoa(ws, e.ijazah_no, "K" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.ijazah_tgl), "L" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },
    wbContentPekerjaan(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Pekerjaan", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Status Pekerjaan", "B" + row);
      this.wbAoa(ws, "Status Pegawai", "C" + row);
      this.wbAoa(ws, "Jabatan", "D" + row);
      this.wbAoa(ws, "Cabang", "E" + row);
      this.wbAoa(ws, "Unit", "F" + row);
      this.wbAoa(ws, "Bagian", "G" + row);
      this.wbAoa(ws, "Bidang", "H" + row);
      this.wbAoa(ws, "Sub Bagian", "I" + row);
      this.wbAoa(ws, "Sub Bidang", "J" + row);
      this.wbAoa(ws, "Seksi", "K" + row);
      this.wbAoa(ws, "Tgl Mulai", "L" + row);
      this.wbAoa(ws, "Tgl Akhir", "M" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status), "B" + row);
        this.wbAoa(
          ws,
          this.prepExcelExpand(e.pegawai_status, "nama"),
          "C" + row
        );
        this.wbAoa(ws, this.prepExcelExpand(e.jabatan, "nama"), "D" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.cabang, "nama"), "E" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.unit, "nama"), "F" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.bagian, "nama"), "G" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.bidang, "nama"), "H" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.sub_bagian, "nama"), "I" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.sub_bidang, "nama"), "J" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.seksi, "nama"), "K" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_mulai_bekerja), "L" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_akhir_bekerja), "M" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentPlt(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat PLT", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Status PLT", "B" + row);
      this.wbAoa(ws, "Jabatan PLT", "C" + row);
      this.wbAoa(ws, "Cabang PLT", "D" + row);
      this.wbAoa(ws, "Unit PLT", "E" + row);
      this.wbAoa(ws, "Bagian PLT", "F" + row);
      this.wbAoa(ws, "Bidang PLT", "G" + row);
      this.wbAoa(ws, "Sub Bagian PLT", "H" + row);
      this.wbAoa(ws, "Sub Bidang PLT", "I" + row);
      this.wbAoa(ws, "Seksi PLT", "J" + row);
      this.wbAoa(ws, "Tgl Mulai PLT", "K" + row);
      this.wbAoa(ws, "Tgl Akhir PLT", "L" + row);
      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status), "B" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.jabatan, "nama"), "C" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.cabang, "nama"), "D" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.unit, "nama"), "E" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.bagian, "nama"), "F" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.bidang, "nama"), "G" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.sub_bagian, "nama"), "H" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.sub_bidang, "nama"), "I" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.seksi, "nama"), "J" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_mulai_bekerja), "K" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_akhir_bekerja), "L" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentTransport(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Pemegang Kendaraan Dinas", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Status", "B" + row);
      this.wbAoa(ws, "Tipe", "C" + row);
      this.wbAoa(ws, "No. Plat", "D" + row);
      this.wbAoa(ws, "Tgl Awal", "E" + row);
      this.wbAoa(ws, "Tgl Akhir", "F" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status), "B" + row);
        this.wbAoa(ws, e.tipe, "C" + row);
        this.wbAoa(ws, e.plat_no, "D" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_awal), "E" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl_akhir), "F" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentNaikPangkat(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Kenaikan Pangkat", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Status", "B" + row);
      this.wbAoa(ws, "Tgl", "C" + row);
      this.wbAoa(ws, "Golongan", "D" + row);
      this.wbAoa(ws, "Capeg", "E" + row);
      this.wbAoa(ws, "Naik Pangkat", "F" + row);
      this.wbAoa(ws, "Masa Kerja (Tahun)", "G" + row);
      this.wbAoa(ws, "Masa Kerja  (Bulan)", "H" + row);
      this.wbAoa(ws, "Keterangan", "I" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status), "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "C" + row);
        this.wbAoa(ws, this.prepExcelExpand(e.golongan, "nama"), "D" + row);
        this.wbAoa(ws, this.prepExcelCapeg(e.capeg), "E" + row);
        this.wbAoa(ws, e.tipe, "F" + row);
        this.wbAoa(ws, e.masa_kerja + " tahun", "G" + row);
        this.wbAoa(ws, e.masa_kerja_bulan + " bulan", "H" + row);
        this.wbAoa(ws, e.ket, "I" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    wbContentKgb(workbook, sheetName, row, data) {
      var ws = workbook.Sheets[sheetName];

      var numbering = 1;
      this.wbAoa(ws, "Riwayat Kenaikan Gaji Berkala", "A" + row);
      row += 2;
      this.wbAoa(ws, "No.", "A" + row);
      this.wbAoa(ws, "Status", "B" + row);
      this.wbAoa(ws, "Tgl", "C" + row);
      this.wbAoa(ws, "Masa Kerja (Tahun)", "D" + row);
      this.wbAoa(ws, "Masa Kerja  (Bulan)", "E" + row);
      this.wbAoa(ws, "Keterangan", "F" + row);

      row += 1;
      data.forEach((e) => {
        this.wbAoa(ws, numbering, "A" + row);
        this.wbAoa(ws, this.prepExcelBool(e.status), "B" + row);
        this.wbAoa(ws, this.prepExcelTgl(e.tgl), "C" + row);
        this.wbAoa(ws, e.masa_kerja + " tahun", "D" + row);
        this.wbAoa(ws, e.masa_kerja_bulan + " bulan", "E" + row);
        this.wbAoa(ws, e.ket, "F" + row);

        numbering += 1;
        row += 1;
      }); //endofforeach
    },

    async onExportingAll() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      const data = {
        pegawaiId: this.pegawaiId,
      };
      const response = await axios.post(
        `${API_BASE_URL}/export_data_pegawai_all`,
        data,
        config
      );
      const dataPegawai = response.data.pegawai;
      const dataKeluarga = response.data.keluargas;
      const dataPendidikan = response.data.pendidikans;
      const dataPekerjaan = response.data.pekerjaans;
      const dataPlt = response.data.plts;
      const dataTransport = response.data.transports;
      const dataNaikPangkat = response.data.naikPangkats;
      const dataKgb = response.data.kgbs;
      console.log("onExportingAll", response);

      const workbook = XLSX.utils.book_new();
      const sheetNamePegawai = "Data Pegawai";
      const sheetNameKeluarga = "Data Keluarga";
      const sheetNamePendidikan = "Riwayat Pendidikan";
      const sheetNamePekerjaan = "Riwayat Pekerjaan";
      const sheetNamePlt = "Riwayat PLT";
      const sheetNameTransport = "Pemegang Kendaraan Dinas";
      const sheetNameNaikPangkat = "Riwayat Kenaikan Pangkat";
      const sheetNameKgb = "Riwayat Kenaikan Gaji Berkala";
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePegawai);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameKeluarga);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePendidikan);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePekerjaan);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNamePlt);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameTransport);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameNaikPangkat);
      XLSX.utils.book_append_sheet(workbook, {}, sheetNameKgb);

      var row = 3;

      //===========================datapegawai===========================
      this.wbContentPegawai(workbook, sheetNamePegawai, row, dataPegawai);
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapegawai===========================
      this.wbContentKeluarga(workbook, sheetNameKeluarga, row, dataKeluarga);
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapegawai===========================
      this.wbContentPendidikan(
        workbook,
        sheetNamePendidikan,
        row,
        dataPendidikan
      );
      /////////////////////////////endofdatapegawai//////////////////////
      //===========================datapegawai===========================
      this.wbContentPekerjaan(workbook, sheetNamePekerjaan, row, dataPekerjaan);
      this.wbContentPlt(workbook, sheetNamePlt, row, dataPlt);
      this.wbContentTransport(workbook, sheetNameTransport, row, dataTransport);
      this.wbContentNaikPangkat(
        workbook,
        sheetNameNaikPangkat,
        row,
        dataNaikPangkat
      );
      this.wbContentKgb(workbook, sheetNameKgb, row, dataKgb);
      /////////////////////////////endofdatapegawai//////////////////////

      XLSX.writeFile(
        workbook,
        "Data Pegawai " + this.pegawaiResponse.nama + ".xlsx"
      );
    },
    onExporting(e, title) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");
      console.log("onExporting", e);

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            title + " - " + this.pegawaiResponse.nama + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    async tetapkanPrediksiKgb() {
      console.log("tetapkanPrediksiKgb");
      //set prediksi kgb into the current kgb
      const data = {
        pegawai_id: this.pegawaiId,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      await axios
        .post(`${API_BASE_URL}/tetapkan_kgb_prediksi`, data, config)
        .then(() => {
          this.$refs.refDataGridKgb.instance.getDataSource().reload();

          this.savedKgb(); //buat kgb prediksi berdasarkan kgb yang baru diinsert
          notify("Penetapan KGB berhasil", "success");
        })
        .catch((error) => {
          console.log(error);
          notify("Penetapan KGB gagal", "error");
        });

      // const response = await axios.post(
      //   "http://127.0.0.1/api/tetapkan_kgb_prediksi",
      //   data,
      //   config
      // );

      // console.log("tetapkanPrediksiKgb", response);
      // if (response) {

      // } else {
      //   notify("Penetapan KGB gagal", "error");

      // }
    },

    async tetapkanPrediksiKp() {
      console.log("tetapkanPrediksiKp");
      //set prediksi kgb into the current kgb
      const data = {
        pegawai_id: this.pegawaiId,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      await axios
        .post(`${API_BASE_URL}/tetapkan_kp_prediksi`, data, config)
        .then(() => {
          this.$refs.refDataGridNaikPangkat.instance.getDataSource().reload();

          this.savedNaikPangkat(); //buat kgb prediksi berdasarkan kgb yang baru diinsert
          notify("Penetapan Kenaikan Pangkat berhasil", "success");
        })
        .catch((error) => {
          console.log(error);
          notify("Penetapan Kenaikan Pangkat gagal", "error");
        });

      // const response = await axios.post(
      //   "http://127.0.0.1/api/tetapkan_kgb_prediksi",
      //   data,
      //   config
      // );

      // console.log("tetapkanPrediksiKgb", response);
      // if (response) {

      // } else {
      //   notify("Penetapan KGB gagal", "error");

      // }
    },
    allow(var1, var2) {
      if (var1 && var2) return true;
      return false;
    },

    async handleClickPrediksiKgb() {
      this.popUpPrediksiKgbVisible = true;
    },

    async handleClickPrediksiKp() {
      this.popUpPrediksiKpVisible = true;
    },
    handleClickPrediksiKgbConfirm() {
      this.popUpPrediksiConfirmVisible = true;
      this.popUpPrediksiConfirmTitle = "Konfirm Penetapan Prediksi KGB";
      this.prediksiConfirmKlik = "kgb";
    },
    handleClickPrediksiKpConfirm() {
      this.popUpPrediksiConfirmVisible = true;
      this.popUpPrediksiConfirmTitle = "Konfirm Penetapan Prediksi KP";
      this.prediksiConfirmKlik = "kp";
    },

    savingTransport(e) {
      if (!this.validateOnlyOneStatusAktif(e)) {
        e.cancel = true;
        if (this.$refs.refDataGridTransport.instance.hasEditData()) {
          this.$refs.refDataGridTransport.instance.cancelEditData();
        }
        notify(
          "HANYA ADA SATU DATA PEMEGANG KENDARAAN DINAS YANG AKTIF",
          "error"
        );
      }
    },

    savingPlt(e) {
      if (!this.validateOnlyOneStatusAktif(e)) {
        e.cancel = true;
        if (this.$refs.refDataGridPlt.instance.hasEditData()) {
          this.$refs.refDataGridPlt.instance.cancelEditData();
        }
        notify("HANYA ADA SATU DATA PLT YANG AKTIF", "error");
      }
    },

    savingPekerjaan(e) {
      console.log("hellooo");
      if (!this.validateOnlyOneStatusAktif(e)) {
        console.log("savingPekerjaan", "validateOnlyOneStatusAktif false");
        e.cancel = true;
        if (this.$refs.refDataGridPekerjaan.instance.hasEditData()) {
          this.$refs.refDataGridPekerjaan.instance.cancelEditData();
        }
        notify("HANYA ADA SATU DATA PEKERJAAN YANG AKTIF", "error");
      } else {
        console.log("savingPekerjaan", "validateOnlyOneStatusAktif true");
      }
    },
    printPrediksiNaikPangkat() {
      if (this.naikPangkatPrediksiResponse) {
        const dateTimeObject = DateTime.fromISO(
          this.naikPangkatPrediksiResponse.tgl
        );
        // Format the DateTime object as a string in the desired format
        var formattedDate = dateTimeObject.toFormat("dd/MM/yyyy");
        var formattedBulan = "";
        if (this.naikPangkatPrediksiResponse.masa_kerja_bulan !== null) {
          formattedBulan =
            this.naikPangkatPrediksiResponse.masa_kerja_bulan + " bulan";
        }

        return (
          formattedDate +
          ", Golongan " +
          this.naikPangkatPrediksiResponse.golongan.nama +
          ", Masa Kerja " +
          this.naikPangkatPrediksiResponse.masa_kerja +
          " tahun " +
          formattedBulan
        );
      }

      return "";
    },
    printPrediksiKgb() {
      if (this.kgbPrediksiResponse) {
        const dateTimeObject = DateTime.fromISO(this.kgbPrediksiResponse.tgl);
        // Format the DateTime object as a string in the desired format
        const formattedDate = dateTimeObject.toFormat("dd/MM/yyyy");

        return (
          formattedDate +
          ", Masa Kerja " +
          this.kgbPrediksiResponse.masa_kerja +
          " tahun " +
          this.kgbPrediksiResponse.masa_kerja_bulan +
          " bulan"
        );
      }

      return "";
    },

    formatCheckbox(data, val, valFalse = null) {
      if (data.value) return val;
      else if (valFalse != null) return valFalse;
    },
    async onRemovedKeluarga(e) {
      console.log("onRemovedKeluarga", e);
      if (
        e.data.pasangan_id !== null &&
        (e.data.keluarga_hub_id == 2 || e.data.keluarga_hub_id == 3)
      ) {
        await this.sinkronPasanganDeleted(e.data);
      }
    },

    async sinkronPasanganDeleted(request) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      const response = await axios.post(
        `${API_BASE_URL}/sinkron_pasangan_deleted`,
        request,
        config
      );
      console.log(response.data);
    },

    namaPasanganBerubah(value, previousValue) {
      console.log("============namaPasanganBerubah===============");
      console.log("Value", value);
      console.log("previousValue", previousValue);
      var valueLen = value.length - 1;
      var ubah = false;
      if ("pasangan_id" in value[valueLen]["data"]) {
        console.log("value length > 0");

        console.log("pasangan_id ubah = true");
        ubah = true;
        if (previousValue.length > 0) {
          console.log("previousValue length > 0 ubah false");
          ubah = false;
          if ("pasangan_id" in previousValue[0]["data"]) {
            if (
              _.get(value[valueLen]["data"], "pasangan_id") !==
              _.get(previousValue[0]["data"], "pasangan_id")
            ) {
              console.log("pasanganId lama != pasanganIdBaru ubah true");
              ubah = true;
            }
          }

          if (
            Object.keys(previousValue[0]["data"]).length === 1 &&
            "pegawai_id" in previousValue[0]["data"]
          ) {
            // The object only has the "pegawai_id" property
            console.log("only have pegawaiId ubah true");
            ubah = true;
          }
        }
      }

      return ubah;
    },
    async onOptionChangedKeluarga(e) {
      console.log("onOptionChangedKeluarga ", e);
      if (e.fullName === "focusedRowKey") {
        this.focusedRowKeyKeluarga = e.value;
        console.log("focusedRowKey", this.focusedRowKeyKeluarga);
      }
      if (e.fullName === "editing.changes") {
        if (this.namaPasanganBerubah(e.value, e.previousValue)) {
          const selectedItem = await this.pegawaiSource.byKey(
            _.get(e.value[0]["data"], "pasangan_id")
          );
          var rowIndex = e.component.getRowIndexByKey(
            this.focusedRowKeyKeluarga
          );

          if (e.value[e.value.length - 1]["type"] == "insert") rowIndex = 0;
          console.log("rowIndex", rowIndex);
          e.component.cellValue(rowIndex, "nama", selectedItem.nama);
          console.log(
            "onOptionChangedKeluarga ubahCellValue",
            selectedItem.nama
          );
        }
      }
    },

    async onSavedKeluarga(e) {
      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: api.defaults.headers.common["Authorization"],
        },
      };
      const response = await axios.post(
        `${API_BASE_URL}/sinkron_pasangan_saved`,
        e.changes[0]["data"],
        config
      );
      console.log("onSavedKeluarga", response);
    },

    async onSavingKeluarga(e) {
      var pasangan_id_baru = null;
      var keluarga_hub_id_baru = null;
      if (_.has(e.changes[0]["data"], "keluarga_hub_id")) {
        keluarga_hub_id_baru = _.get(e.changes[0]["data"], "keluarga_hub_id");
      }

      if (_.has(e.changes[0]["data"], "pasangan_id")) {
        pasangan_id_baru = _.get(e.changes[0]["data"], "pasangan_id");
        //ada perubahan pasangan_id, lakukan sinkron
        const dataSource = e.component.getDataSource();
        const dataLama = dataSource
          .items()
          .find((item) => item.id === e.changes[0]["key"]);
        var pasangan_id_lama = dataLama.pasangan_id;
        if (pasangan_id_lama !== null) {
          //lakukan sinkron
          await this.sinkronPasanganSaving(
            pasangan_id_lama,
            pasangan_id_baru,
            dataLama.pegawai_id,
            this.yangManaYa(keluarga_hub_id_baru, dataLama.keluarga_hub_id)
          );
        } else {
          //tidak lakukan sinkron, karena data lama memang tidak punya pasangan_id,
          //tidak perlu melakukan perubahan di tabel pasangan
        }
      }

      e.cancel = false;
    },
    yangManaYa(baru, lama) {
      if (baru !== null) return lama;
      return baru;
    },
    async sinkronPasanganSaving(
      pasangan_id_lama,
      pasangan_id_baru,
      pegawai_id,
      keluarga_hub_id
    ) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        pasangan_id_lama: pasangan_id_lama,
        pasangan_id_baru: pasangan_id_baru,
        pegawai_id: pegawai_id,
        keluarga_hub_id: keluarga_hub_id,
      };
      const response = await axios.post(
        `${API_BASE_URL}/sinkron_pasangan_saving`,
        data,
        config
      );
      console.log(response.data);
    },

    async savedNaikPangkat(e) {
      console.log("savedNaikPangkat", e);

      const data = {
        pegawai_id: this.pegawaiId,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      const response = await axios.post(
        `${API_BASE_URL}/sinkron_kp_prediksi`,
        data,
        config
      );

      this.naikPangkatPrediksiResponse =
        await this.fetchDataNaikPangkatPrediksi();

      console.log("savedNaikPangkat response", response);
    },

    async savedKgb(e) {
      console.log("savedKgb", e);

      const data = {
        pegawai_id: this.pegawaiId,
      };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };

      const response = await axios.post(
        `${API_BASE_URL}/sinkron_kgb_prediksi`,
        data,
        config
      );

      this.kgbPrediksiResponse = await this.fetchDataKgbPrediksi();

      console.log("savedKgb response", response);
    },

    async savingKgb(e) {
      const isHonorOrKontrak = _.filter(
        this.pekerjaanDataSource.items(),
        (item) => item.pegawai_status_id > 3 && item.status === true
      );

      console.log("savingKgb isHonorOrKontrak", isHonorOrKontrak);
      if (isHonorOrKontrak.length > 0) {
        e.cancel = true;
        if (this.$refs.refDataGridKgb.instance.hasEditData()) {
          this.$refs.refDataGridKgb.instance.cancelEditData();
        }
        alert("Pekerja honor/kontrak tidak memiliki data kgb");
        return;
      }

      if (!this.validateOnlyOneStatusAktif(e)) {
        e.cancel = true;
        if (this.$refs.refDataGridKgb.instance.hasEditData()) {
          this.$refs.refDataGridKgb.instance.cancelEditData();
        }
        notify("HANYA ADA SATU DATA KGB YANG AKTIF", "error");
      }

      // e.cancel = true;
    },

    validateOnlyOneStatusAktif(e) {
      console.log("validateOnlyOneStatusAktif e", e);
      // const countStatusFromDS = 0;
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), { status: true })
      );
      console.log(
        "validateOnlyOneStatusAktif countStatusFromDS",
        countStatusFromDS
      );

      const countStatusFromDSList = _.filter(
        e.component.getDataSource().items(),
        { status: true }
      );
      console.log(
        "validateOnlyOneStatusAktif countStatusFromDSList",
        countStatusFromDSList
      );
      let countStatusFromChanges = 0;

      if (
        e.changes[0] &&
        typeof e.changes[0].data === "object" &&
        "status" in e.changes[0].data
      ) {
        console.log(
          "validateOnlyOneStatusAktif masuk ada status",
          e.changes[0].data.status
        );
        if (e.changes[0].data.status) countStatusFromChanges = 1;
      }

      console.log(
        "validateOnlyOneStatusAktif countStatusFromDSList",
        countStatusFromDSList
      );
      console.log(
        "validateOnlyOneStatusAktif countStatusFromChanges",
        countStatusFromChanges
      );
      console.log(
        "validateOnlyOneStatusAktif countStatusFromDS",
        countStatusFromDS
      );

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    async savingNaikPangkat(e) {
      //tidak boleh save naikPangkat jika adalah kontrak atau honor
      console.log(
        "savingNaikPangkat pekerjaanDataSource",
        this.pekerjaanDataSource.items()
      );

      const isHonorOrKontrak = _.filter(
        this.pekerjaanDataSource.items(),
        (item) => item.pegawai_status_id > 3 && item.status === true
      );
      console.log("savingNaikPangkat isHonorOrKontrak", isHonorOrKontrak);

      if (isHonorOrKontrak.length > 0) {
        e.cancel = true;
        if (this.$refs.refDataGridNaikPangkat.instance.hasEditData()) {
          this.$refs.refDataGridNaikPangkat.instance.cancelEditData();
        }
        alert("Pekerja honor/kontrak tidak memiliki data naik pangkat");
      }

      console.log("====================savingNaikPangkat================");
      console.log("savingNaikPangkat ds", e.component.getDataSource());
      console.log(
        "savingNaikPangkat naikPangkatResponse",
        this.naikPangkatResponse.items()
      );
      console.log("savingNaikPangkat changes", e.changes);

      console.log(
        "savingNaikPangkat validateOnlyOneStatusAktif",
        this.validateOnlyOneStatusAktif(e)
      );
      if (!this.validateOnlyOneStatusAktif(e)) {
        e.cancel = true;
        if (this.$refs.refDataGridNaikPangkat.instance.hasEditData()) {
          this.$refs.refDataGridNaikPangkat.instance.cancelEditData();
        }
        notify("HANYA ADA SATU DATA KENAIKAN PANGKAT YANG AKTIF", "error");
      }

      //sinkron prediksi
    },

    formatPenyesuaian(data) {
      if (data.value) {
        return "Penyesuaian";
      }
    },
    formatCapeg(data) {
      console.log("formatCapeg", data.value);
      if (data.value) {
        return "80%";
      }
    },
    bulanUbah(bulan) {
      this.naikPangkatResponse = this.naikPangkatResponse.map((item) => {
        var originalDate = DateTime.fromISO(item.tgl);
        var newDate = originalDate.set({ month: bulan });
        return {
          ...item,
          tgl: newDate.toISODate(), // Convert the Luxon DateTime object back to a string (if needed)
        };
      });

      // console.log("modif", this.naikPangkatResponse);
    },
    bulanUbahKGB(bulan) {
      this.kgbResponse = this.kgbResponse.map((item) => {
        var originalDate = DateTime.fromISO(item.tgl);
        var newDate = originalDate.set({ month: bulan });
        return {
          ...item,
          tgl: newDate.toISODate(), // Convert the Luxon DateTime object back to a string (if needed)
        };
      });

      // console.log("modif", this.naikPangkatResponse);
    },

    tahunTambahKGB(operator) {
      // console.log("asli", this.naikPangkatResponse);
      this.kgbResponse = this.kgbResponse.map((item) => {
        // Convert the 'tgl' property from string to Luxon DateTime object
        var originalDate = DateTime.fromISO(item.tgl);

        // Add one year to the date
        var newDate;
        if (operator == "add") newDate = originalDate.plus({ years: 1 });
        else newDate = originalDate.minus({ years: 1 });
        // Update the 'tgl' property for the current element with the new date
        return {
          ...item,
          tgl: newDate.toISODate(), // Convert the Luxon DateTime object back to a string (if needed)
        };
      });

      // console.log("modif", this.naikPangkatResponse);
    },

    tahunTambah(operator) {
      // console.log("asli", this.naikPangkatResponse);
      this.naikPangkatResponse = this.naikPangkatResponse.map((item) => {
        // Convert the 'tgl' property from string to Luxon DateTime object
        var originalDate = DateTime.fromISO(item.tgl);

        // Add one year to the date
        var newDate;
        if (operator == "add") newDate = originalDate.plus({ years: 1 });
        else newDate = originalDate.minus({ years: 1 });
        // Update the 'tgl' property for the current element with the new date
        return {
          ...item,
          tgl: newDate.toISODate(), // Convert the Luxon DateTime object back to a string (if needed)
        };
      });

      // console.log("modif", this.naikPangkatResponse);
    },

    golUbah(operator) {
      // console.log("asli", this.naikPangkatResponse);
      this.naikPangkatResponse = this.naikPangkatResponse.map((item) => {
        // Convert the 'tgl' property from string to Luxon DateTime object

        // Add one year to the date
        var newData;
        if (operator == "add") newData = item.golongan_id + 1;
        else newData = item.golongan_id - 1;

        if (newData > 19) newData = 19;

        // Update the 'tgl' property for the current element with the new date
        return {
          ...item,
          golongan_id: newData, // Convert the Luxon DateTime object back to a string (if needed)
        };
      });

      // console.log("modif", this.naikPangkatResponse);
    },

    hariTambah(operator) {
      // console.log("asli", this.naikPangkatResponse);
      this.naikPangkatResponse = this.naikPangkatResponse.map((item) => {
        // Convert the 'tgl' property from string to Luxon DateTime object
        var originalDate = DateTime.fromISO(item.tgl);

        // Add one year to the date
        var newDate;
        if (operator == "add") newDate = originalDate.plus({ days: 1 });
        else newDate = originalDate.minus({ days: 1 });
        // Update the 'tgl' property for the current element with the new date
        return {
          ...item,
          tgl: newDate.toISODate(), // Convert the Luxon DateTime object back to a string (if needed)
        };
      });

      // console.log("modif", this.naikPangkatResponse);
    },

    saveKP() {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const data = {
        data: this.naikPangkatResponse,
      };

      axios
        .post(`${API_BASE_URL}/save_kp`, data, config)
        .then((res) => {
          console.log(res);
          notify(res.data.message, "success");
        })
        .catch((error) => {
          notify(error.data.message, "error");
          console.log(error);
        });
    },
    saveKGB() {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const data = {
        data: this.kgbResponse,
      };

      axios
        .post(`${API_BASE_URL}/save_kgb`, data, config)
        .then((res) => {
          console.log(res);
          notify(res.data.message, "success");
        })
        .catch((error) => {
          notify(error.data.message, "error");
          console.log(error);
        });
    },

    resetKP() {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const data = {
        pegawai_id: this.pegawaiId,
      };

      axios
        .post(`${API_BASE_URL}/generate_kp`, data, config)
        .then((res) => {
          console.log(res);
          console.log(this.pegawaiId);
          this.naikPangkatResponse = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    resetKGB() {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const data = {
        pegawai_id: this.pegawaiId,
      };

      axios
        .post(`${API_BASE_URL}/generate_kgb`, data, config)
        .then((res) => {
          console.log(res);
          console.log(this.pegawaiId);
          this.kgbResponse = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    enterKey(e) {
      console.log("enterkey", e);
    },
    handleClickDocumentLAMA(e, table, tableRef) {
      if (this.allowFileUpload()) {
        this.popupFileVisible = true;
        this.fileUrl = e.data.file_path;
        this.fileTableId = e.data.id;
        this.fileTable = table;
        this.$refs.fileUploader.instance.reset();
        this.fileTableRef = tableRef;
      } else {
        this.fileUrl = e.data.file_path;
        this.downloadFile();
      }
    },

    handleClickDocument(e) {
      if (e.data.file_path !== null)
        window.open(
          this.serverUrl + e.data.file_path,
          "_blank",
          "location=yes"
        );
    },

    async fetchDataPegawai() {
      const odataStore = new ODataStore({
        type: "odata",
        url:
          `${ODATA_BASE_URL}/SimpegPegawais?$filter=id eq ` +
          this.pegawaiId +
          `&$expand=agama`,
        key: "id",
        version: 4,
        beforeSend: function (e) {
          e.headers = {
            "odata-version": "4.0",
          };
          console.log("hello2");
        },
        expand: ["agama"],
      });
      const data = await odataStore.load({});

      return data[0];
    },
    fetchDataKeluarga() {
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/RiwayatKeluargas`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        filter: ["pegawai_id", this.pegawaiId],
        expand: ["pasangan"],
      });
      return odataStore;
      // const data = await odataStore.load({});
      // return data;
    },

    fetchDataPendidikan() {
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/RiwayatPendidikans`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        filter: ["pegawai_id", this.pegawaiId],
      });
      // const data = await odataStore.load({});
      // return data;
      return odataStore;
    },

    fetchDataNaikPangkat() {
      var filterKP = [
        ["pegawai_id", "=", this.pegawaiId],
        ["show", "=", true],
      ];

      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/SimpegNaikPangkats`,
          key: "id",
          version: 4,
          withCredentials: true,
          beforeSend: (e) => {
            e.headers = {
              "odata-version": "4.0",
              Authorization: api.defaults.headers.common["Authorization"],
            };
            console.log("debug filterKP", e.params);
            if (!e.params.$filter || e.params.$filter.trim() === "") {
              e.params.$filter =
                "(pegawai_id eq " + this.pegawaiId + ") and (show eq true)";
            } else if (!e.params.$filter.includes("show eq true")) {
              e.params.$filter += " and (show eq true)";
            }
          },
        }),
        expand: ["pegawai"],
        // filter: [
        //   ["pegawai_id", "=", this.pegawaiId],
        //   ["show", "=", true],
        // ],
        filter: filterKP,
      });
      return dataSource;
    },

    async fetchDataNaikPangkatPrediksi() {
      console.log("fetchDataNaikPangkatPrediksi");
      const dataSource = new DataSource({
        store: new ODataStore({
          // ODataStore is configured here
          url: `${ODATA_BASE_URL}/SimpegNaikPangkatPrediksis`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        expand: ["golongan"],
        filter: [["pegawai_id", "=", this.pegawaiId]],
      });

      const data = await dataSource.load({});

      return data[0];
    },

    async fetchDataKgbPrediksi() {
      const dataSource = new DataSource({
        store: new ODataStore({
          // ODataStore is configured here
          url: `${ODATA_BASE_URL}/SimpegKgbPrediksis`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        filter: [
          ["pegawai_id", "=", this.pegawaiId],
          ["versi", "=", 2], //diubah ke versi 1
        ],
      });

      const data = await dataSource.load({});

      return data[0];
    },

    fetchDataKgb() {
      const dataSource = new DataSource({
        store: new ODataStore({
          // ODataStore is configured here
          url: `${ODATA_BASE_URL}/SimpegKgbs`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        expand: ["pegawai"],
        filter: ["pegawai_id", "=", this.pegawaiId],
      });
      return dataSource;
    },
    fetchDataPekerjaan() {
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/RiwayatPekerjaans`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        filter: ["pegawai_id", this.pegawaiId],
      });
      // const data = await odataStore.load({});
      // return data;
      return odataStore;
    },

    fetchDataPlt() {
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/RiwayatPlts`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        filter: ["pegawai_id", this.pegawaiId],
      });
      // const data = await odataStore.load({});
      // return data;
      return odataStore;
    },

    fetchDataTransport() {
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/RiwayatTransports`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
          },
        }),
        filter: ["pegawai_id", this.pegawaiId],
      });
      // const data = await odataStore.load({});
      // return data;
      return odataStore;
    },

    refreshDatagrid(ref) {
      const dataGridInstance = this.$refs[ref].instance;
      dataGridInstance
        .getDataSource()
        .filter(["pegawai_id", "=", this.pegawaiId]);
      dataGridInstance.getDataSource().reload();
    },

    async lihatPegawai() {
      this.loadingVisible = true;

      this.pegawaiResponse = await this.fetchDataPegawai();
      document.title = this.pegawaiResponse.nama + " - Detail Pegawai";
      console.log("debug document ", document.title);
      this.naikPangkatPrediksiResponse =
        await this.fetchDataNaikPangkatPrediksi();
      this.kgbPrediksiResponse = await this.fetchDataKgbPrediksi();
      this.loadingVisible = false;
      const refKeluarga = this.$refs["refDataGridKeluarga"];
      const refPendidikan = this.$refs["refDataGridPendidikan"];
      const refPekerjaan = this.$refs["refDataGridPekerjaan"];
      const refPlt = this.$refs["refDataGridPlt"];
      const refTransport = this.$refs["refDataGridTransport"];
      const refNaikPangkat = this.$refs["refDataGridNaikPangkat"];
      const refKgb = this.$refs["refDataGridKgb"];

      if (!refPekerjaan) {
        this.pekerjaanDataSource = this.fetchDataPekerjaan();
      } else {
        this.refreshDatagrid("refDataGridPekerjaan");
      }
      if (!refKeluarga) {
        this.keluargaDataSource = this.fetchDataKeluarga();
      } else {
        this.refreshDatagrid("refDataGridKeluarga");
      }
      if (!refPendidikan) {
        this.pendidikanDataSource = this.fetchDataPendidikan();
      } else {
        this.refreshDatagrid("refDataGridPendidikan");
      }
      if (!refPlt) {
        this.pltDataSource = this.fetchDataPlt();
      } else {
        this.refreshDatagrid("refDataGridPlt");
      }
      if (!refTransport) {
        this.transportDataSource = this.fetchDataTransport();
      } else {
        this.refreshDatagrid("refDataGridTransport");
      }
      if (!refNaikPangkat) {
        this.naikPangkatResponse = this.fetchDataNaikPangkat();
      } else {
        this.refreshDatagrid("refDataGridNaikPangkat");
      }
      if (!refKgb) {
        this.kgbResponse = this.fetchDataKgb();
      } else {
        this.refreshDatagrid("refDataGridKgb");
      }

      this.displayStatusAktif(this.pegawaiResponse.status_aktif_id);
    },

    async lihatPegawai2() {
      this.loadingVisible = true;
      console.log("debug lihatpegawaix", this.pegawaiId);
      this.pegawaiResponse = await this.fetchDataPegawai();

      this.loadingVisible = false;
      this.keluargaDataSource = this.fetchDataKeluarga();
      this.$refs.refDataGridKeluarga.instance.getDataSource().reload();
      this.pendidikanDataSource = this.fetchDataPendidikan();
      this.$refs.refDataGridPendidikan.instance.getDataSource().reload();
      this.pekerjaanDataSource = this.fetchDataPekerjaan();
      this.$refs.refDataGridPekerjaan.instance.getDataSource().reload();
      this.pltDataSource = this.fetchDataPlt();
      this.$refs.refDataGridPlt.instance.getDataSource().reload();
      this.transportDataSource = this.fetchDataTransport();
      this.$refs.refDataGridTransport.instance.getDataSource().reload();
      this.naikPangkatResponse = this.fetchDataNaikPangkat();
      this.$refs.refDataGridNaikPangkat.instance.getDataSource().reload();
      this.kgbResponse = this.fetchDataKgb();
      this.$refs.refDataGridKgb.instance.getDataSource().reload();
      this.naikPangkatPrediksiResponse =
        await this.fetchDataNaikPangkatPrediksi();

      this.displayStatusAktif(this.pegawaiResponse.status_aktif_id);
    },
    applySearch(searchQuery) {
      const filterOption = [];

      // Add your specific filter conditions based on your data model
      if (searchQuery) {
        filterOption.push(["nama", "contains", searchQuery]);
      }

      // Set the filter option of the ODataStore
      this.cabangSource.filter(filterOption);
    },

    displayBoolean(data) {
      if (data === null || data == false) return "Tidak Aktif";
      return "Aktif";
    },

    async displayStatusAktif(data) {
      console.log("displayStatusAktif", data);

      let value = this.statusAktifStore.find(data);

      this.statusAktifNama = value.nama;
      console.log("displayStatusAktif statusAktifNama", this.statusAktifNama);
      // this.statusAktifSource
      //   .load({
      //     filter: ["id", "=", data],
      //   })
      //   .then((data) => {
      //     if (data.length > 0) {
      //       const desiredRow = data[0]; // First row with the desired ID
      //       console.log(desiredRow); // Log the entire row object
      //       const value = desiredRow.nama; // Replace yourColumn with the actual column name
      //       console.log(value);
      //       this.statusAktifNama = value;

      //       // return value; // Log the value of the specific column
      //     } else {
      //       console.log("No row found with the desired ID");
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error loading data:", error);
      //   });
    },
    displayAgama(data) {
      if (data === null) {
        return "";
      } else {
        return data.nama;
      }
    },

    handleClickDeletePasangan() {
      this.popupPasanganVisible = false;
      const dataGridInstance = this.$refs.refDataGridKeluarga.instance;
      dataGridInstance.cellValue(this.rKeluargaRowIndex, "pasangan.nik", "");

      dataGridInstance.cellValue(this.rKeluargaRowIndex, "pasangan_id", "");
      dataGridInstance.saveEditData();
    },
    handleClickPilihPasangan(data) {
      this.popupPasanganVisible = false;

      const dataGridInstance = this.$refs.refDataGridKeluarga.instance;

      dataGridInstance.cellValue(
        this.rKeluargaRowIndex,
        "pasangan_id",
        data.data.id
      );
      dataGridInstance.saveEditData();
    },
    downloadFile() {
      if (this.fileUrl !== null) {
        console.log("ADA FILE DOWNLOAD");
        window.open(this.serverUrl + this.fileUrl, "_self", "location=yes");
      } else {
        console.log("TIDAK ADA");
        notify("File tidak ada", "error");
      }
    },
    cellClicked(e) {
      console.log(e);
      if (e.column.dataField == "ijazah_file") {
        this.dataGridPopupCurrDataIdPendidikan = e.key; //pendidikanFile yg sedang di edit
      }
    },
    showPopUpPasangan(data) {
      if (data.data.keluarga_hub_id === 2 || data.data.keluarga_hub_id === 3) {
        //jika suami/istri
        return true;
      } else return false;
    },
    handleClickPopUpFile() {
      this.popupFileVisible = true;
    },
    handleClickPopUpPasangan(data) {
      this.rKeluargaRowIndex = data.rowIndex;
      this.popupPasanganVisible = true;
    },
    handleFileUploader(e, column) {
      if (column == "pegawai_foto") this.fotoPegawai = e.value[0];
      if (column == "file_path") {
        this.file = e.value[0];
        // this.uploadFile();
      }
    },

    uploadFile(action = null) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };

      const formData = new FormData();
      formData.append("id", this.fileTableId);
      formData.append("table", this.fileTable);
      formData.append("action", action);
      formData.append("file", this.file); //file yg baru
      //TODO: tambahkan file yang lama biar bisa didelete?
      axios
        .post(`${API_BASE_URL}/upload_file_` + this.fileTable, formData, config)
        .then((response) => {
          console.log(response);
          console.log("filetableref", this.fileTableRef);
          console.log(
            "reftableinstance",
            this.$refs[this.fileTableRef].instance
          );
          // this.$refs[this.fileTableRef].instance.getDataSource().reload();
          this.$refs[this.fileTableRef].instance.refresh();
          // this.fileUrl = this.serverUrl + this.pegawaiResponse.file_path;
          notify(response.data.message, response.data.notify_type);
          this.popupVisible = false;
          this.file = null;
          // reactivity system will update HTML automatically
        })
        .catch((error) => {
          this.file = null;
          notify("Gagal upload file", "error");
          console.log(error);
        });
    },

    updateFotoPegawai() {
      console.log(this.fotoPegawai);
      const config = {
        headers: {
          // "content-type": "application/json",
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      const formData = new FormData();
      // formData.append("pegawai_id", getPegawaiId());
      formData.append("pegawai_id", this.pegawaiId);
      formData.append(
        "pegawai_foto_path_old",
        this.pegawaiResponse.pegawai_foto_path
      );
      formData.append("pegawai_foto", this.fotoPegawai); //foto yg baru
      formData.append("pegawai_foto_old", this.pegawaiResponse.pegawai_foto);
      axios
        .post(`${API_BASE_URL}/simpeg_update_foto_pegawai`, formData, config)
        .then((response) => {
          console.log(response);
          this.pegawaiResponse.pegawai_foto_path =
            response.data.pegawai_foto_path;

          this.imageUrl =
            this.serverUrl + this.pegawaiResponse.pegawai_foto_path;
          this.$refs.fileUploaderFoto.instance.reset();
          notify("Foto pegawai berhasil diupdate.", "success");
          this.popupVisible = false;
          // reactivity system will update HTML automatically
        })
        .catch((error) => {
          notify("Foto pegawai gagal diupdate.", "error");
          console.log(error);
        });

      // .then(function (res) {
      //   console.log(res);
      //   notify("Axios post success.", "success");
      // })
      // .catch(function (err) {
      //   console.log(err);
      //   notify("Axios post error.", "error");
      // });
    },
    popUpProfile(e) {
      console.log(e);
      if (this.can("pegawai-update")) this.popupVisible = true;
    },

    startEditing() {
      if (this.editing) this.editing = false;
      else this.editing = true;
    },
    formatTgl(date) {
      if (date === null) return "";
      return formatDateDisplay(date);
    },
    formatTglLahir() {
      // if (this.pegawaiResponse.tgl_lahir === "") return "";

      if (!this.pegawaiResponse.tgl_lahir) {
        return null;
      }

      return formatDateDisplay(this.pegawaiResponse.tgl_lahir);
    },
    formatTglMulaiBekerja() {
      return formatDateDisplay(this.pegawaiResponse.tgl_mulai_bekerja);
    },

    itemClick(e) {
      this.tabSource = this.tabMenus[e.itemData.templateIndex].items;
      this.treeData.forEach((item, index) => {
        //selected flag utk menu
        if (index == e.itemData.templateIndex) item.selected = true;
        else item.selected = false;
      });
    },
    async simpanPrediksiKgb(e) {
      const result = e.validationGroup.validate();
      console.log("simpanPrediksiKgb", e);

      if (result.isValid) {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var pakaiIni;

        if (this.kgbPrediksiResponse) {
          pakaiIni = this.kgbPrediksiResponse;
        } else pakaiIni = this.kgbPrediksiResponseAdd;

        var data = {
          pegawai_id: this.pegawaiId,
          tgl: pakaiIni.tgl,
          masa_kerja: pakaiIni.masa_kerja,
          masa_kerja_bulan: pakaiIni.masa_kerja_bulan,
        };

        //lakukan update prediksi kgb
        await axios
          .post(`${API_BASE_URL}/prediksi_kgb_simpan`, data, config)
          .then(() => {
            notify("Prediksi KGB berhasil disimpan", "success");
          })
          .catch((error) => {
            console.log(error);
            notify("Prediksi KGB gagal disimpan", "error");
          });
      } else {
        notify(
          "Data Prediksi KGB gagal diperbarui. Mohon cek bahwa semua input adalah valid.",
          "error"
        );
      }
      this.popUpPrediksiKgbVisible = false;

      this.kgbPrediksiResponse = await this.fetchDataKgbPrediksi();

      this.printPrediksiKgb();
    },

    async simpanPrediksiKp(e) {
      const result = e.validationGroup.validate();
      console.log("simpanPrediksiKp", e);

      if (result.isValid) {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var pakaiIni;

        if (this.naikPangkatPrediksiResponse) {
          pakaiIni = this.naikPangkatPrediksiResponse;
        } else pakaiIni = this.naikPangkatPrediksiResponseAdd;

        console.log("biasa", this.naikPangkatPrediksiResponse);
        console.log("add", this.naikPangkatPrediksiResponseAdd);

        var data = {
          // id: this.naikPangkatPrediksiResponse.id,
          pegawai_id: this.pegawaiId,
          tgl: pakaiIni.tgl,
          golongan_id: pakaiIni.golongan_id,
          masa_kerja: pakaiIni.masa_kerja,
          masa_kerja_bulan: pakaiIni.masa_kerja_bulan,
        };

        console.log("simpanPrediksiKp", data);

        //lakukan update prediksi kgb
        await axios
          .post(`${API_BASE_URL}/prediksi_kp_simpan`, data, config)
          .then(() => {
            notify("Prediksi Kenaikan Pangkat berhasil disimpan", "success");
          })
          .catch((error) => {
            console.log(error);
            notify("Prediksi Kenaikan Pangkat gagal disimpan", "error");
          });
        // prediksiKgbSource
        //   .update(
        //     { id: this.kgbPrediksiResponse.id },
        //     {
        //       tgl: formatDateISO(this.kgbPrediksiResponse.tgl),
        //       masa_kerja: this.kgbPrediksiResponse.masa_kerja,
        //       masa_kerja_bulan: this.kgbPrediksiResponse.masa_kerja_bulan,
        //     }
        //   )
        //   .then(
        //     (dataObj) => {
        //       notify("Data Prediksi KGB sukses diperbarui", "success");
        //     },
        //     (error) => {
        //       console.log(error);
        //       notify("Data Prediksi KGB gagal diperbarui", "error");
        //     }
        //   );
      } else {
        notify(
          "Data Prediksi Kenaikan Pangkat gagal diperbarui. Mohon cek bahwa semua input adalah valid.",
          "error"
        );
      }
      this.popUpPrediksiKpVisible = false;
      this.naikPangkatPrediksiResponse =
        await this.fetchDataNaikPangkatPrediksi();

      this.printPrediksiNaikPangkat();
    },

    async validateClick(from, e) {
      this.editing = true; // FIXME: NANTI DIHAPUS YAA,
      console.log("validateClick response", this.pegawaiResponse);

      const result = e.validationGroup.validate();
      if (result.isValid) {
        // this.pegawaiResponse.tgl_lahir = formatDateISO(
        //   this.pegawaiResponse.tgl_lahir
        // );
        // this.pegawaiResponse.tgl_mulai_bekerja = formatDateISO(
        //   this.pegawaiResponse.tgl_mulai_bekerja
        // );
        // this.pegawaiResponse.tgl_diangkat = formatDateISO(
        //   this.pegawaiResponse.tgl_diangkat
        // );
        // this.pegawaiResponse.pensiun_tgl = formatDateISO(
        //   this.pegawaiResponse.pensiun_tgl
        // );
        if (this.pegawaiResponse.nik === "") this.pegawaiResponse.nik = null;
        const updatedData = {
          nama: this.pegawaiResponse.nama,
          nik: this.pegawaiResponse.nik,
          alamat: this.pegawaiResponse.alamat,
          tempat_lahir: this.pegawaiResponse.tempat_lahir,
          tgl_lahir: formatDateISO(this.pegawaiResponse.tgl_lahir),
          tgl_mulai_bekerja: formatDateISO(
            this.pegawaiResponse.tgl_mulai_bekerja
          ),
          telp: this.pegawaiResponse.telp,
          agama_id: this.pegawaiResponse.agama_id,
          pensiun_jiwasraya: this.pegawaiResponse.pensiun_jiwasraya,
          pph: this.pegawaiResponse.pph,
          status_ptkp: this.pegawaiResponse.status_ptkp,
          status_aktif_id: this.pegawaiResponse.status_aktif_id,
          pensiun_tgl: formatDateISO(this.pegawaiResponse.pensiun_tgl),
          tgl_diangkat: formatDateISO(this.pegawaiResponse.tgl_diangkat),
          jenis_kelamin: this.pegawaiResponse.jenis_kelamin,
        };

        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        console.log("validateClick responseUpdated", updatedData);

        try {
          const response = await axios.put(
            `${API_BASE_URL}/simpeg_pegawai/${this.pegawaiResponse.id}/update`,
            updatedData,
            config
          );

          if (response.data.status) {
            this.editing = false; // FIXME: NANTI uncomment yaa
            this.pegawaiResponse = response.data.data;
            this.displayStatusAktif(this.pegawaiResponse.status_aktif_id);

            notify("Data pegawai sukses diperbarui", "success");
            console.log("validateClick pegawairesponse", this.pegawaiResponse);
            this.disableDatagridBasedOnStatusAktifPegawai();
          } else {
            notify("Data pegawai gagal diperbarui.", "error");
          }
        } catch (error) {
          console.log(error);
          notify(
            "Data pegawai gagal diperbarui. Mohon cek bahwa semua input adalah valid.",
            "error"
          );
        }
      }
    },

    disableDatagridBasedOnStatusAktifPegawai() {
      if (this.pegawaiResponse.status_aktif_id !== 1) {
        this.allowUpdating = false;
        this.allowAdding = false;
        this.allowDeleting = false;
      } else {
        this.allowUpdating = true;
        this.allowAdding = true;
        this.allowDeleting = true;
      }
    },
    delPegawaiBtn() {
      let result = confirm(
        "<strong>Yakin menghapus data pegawai?</strong> <br>Semua data bersangkutan akan dihapus termasuk data personal dan pekerjaan",
        "Konfirmasi Hapus Pegawai"
      );
      result.then((dialogResult) => {
        console.log(dialogResult);
        if (dialogResult) {
          //delete
          const config = {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "content-type": "application/json",
            },
          };
          axios
            .post(
              `${API_BASE_URL}/simpeg_pegawai/delete`,
              this.pegawaiId,
              config
            )
            .then((response) => {
              console.log(response);
              // notify("Data Pegawai berhasil dihapus", "success");
              notify(response.data.message, response.data.notify_type);

              if (response.data.status) {
                router.push({
                  name: "pegawai-list-custom",
                });
              }
            })
            .catch((error) => {
              notify(error.data.message, error.data.notify_type);
              console.log(error);
            });
        }
      });
    },
    logEvent(eventName) {
      console.log(eventName);
    },
    initialPegawaiId(event, table) {
      this.file = null;
      this.fileName = null;
      this.filePath = null;
      console.log(event);
      if (table == "refDataGridPendidikan") {
        event.data.status_penyesuaian = false;
        console.log("hello");
      }

      if (table == "refDataGridNaikPangkat") {
        event.data.status_penyesuaian = false;
        event.data.status = false;
        event.data.capeg = false;
      }
      // event.data = { pegawai_id: this.pegawaiId };
      event.data.pegawai_id = this.pegawaiId;
    },
  },
};
</script>
<style scoped>
/* .small-button-container {
  display: inline-block;
  padding: 0;
  margin: 0;
}

.small-button-container .dx-button {
  padding: 0;
  font-size: 12px;
} */
.formA {
  margin-left: 3px;
}

.formA > div:first-child {
  margin-right: 320px;
}

.label {
  font-size: 18px;
  font-weight: 500;
}

#product-details {
  width: 400px;
  height: 400px;
  margin: 20px auto 0;
}

#product-details > img {
  height: 300px;
  width: 400px;
}

#product-details > .name {
  text-align: center;
  font-size: 20px;
}

#product-details > .price {
  text-align: center;
  font-size: 24px;
}

.dark #product-details > div {
  color: #f0f0f0;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}

.hidden {
  visibility: hidden;
}

.dx-menu-item-selected {
  background-color: rgba(0, 0, 0, 0.87) !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.title-container-pegawai {
  /* min-height: 100px; */
  margin-bottom: 10px;
  padding-bottom: 2px;
  padding-top: 15px;
}

.title-pegawai2 {
  /* padding: 0 0 20px 0; */
  /* padding-top: 70px; */
  padding: 1px;

  display: block;
  /* background-color: rgba(191, 191, 191, 0.15);
  background-clip: content-box; */
}

.job-history-title {
  font-size: 15px;
}

.flag-pegawai2 {
  float: left;
  height: 100px;
  width: 106px;
  margin: 0 10px 10px 0;
  border: 1px solid #d2d3d5;
  border-radius: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  overflow: hidden;

  /* img {
    
  } */
}

img {
  height: 100px;
  display: block;
  margin: 0 auto;
}
</style>
